// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T23:01:12.158Z
// Property: Prairie Creek Apartments & Townhomes (ID: 6767906449167608)
// Collections: 38 amenities, 15 floorplans (live), 52 photos, 75 POIs, 3 reviews, 14 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162465",
  "multihub_property_id": "6767906449167608",
  "property_external_id": "1107322",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/prairie-creek-apartments-townhomes-lenexa-ks/kkdz3t9/",
  "property_google_business_url": "https://www.google.com/maps/place/Prairie+Creek+Apartments+%26+Townhomes/@38.9577378,-94.7815721,769m/data=!3m2!1e3!4b1!4m6!3m5!1s0x87c0946f32829c3f:0x709768bb2f8adfef!8m2!3d38.9577378!4d-94.7815721!16s%2Fg%2F12hwd20xb?entry=ttu&g_ep=EgoyMDI2MDkxNi4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "prairie-creek-apartments-&-townhomes",
  "property_name": "Prairie Creek Apartments & Townhomes",
  "property_website_url": "https://www.prairiecreekapartments.com/",
  "property_domain": "https://www.prairiecreekapartments.com/",
  "property_address": "9395 Scarborough St",
  "property_full_address": "9395 Scarborough St, Lenexa, KS 66219",
  "property_address_1": "9395 Scarborough St",
  "property_address_2": null,
  "property_address_city": "Lenexa",
  "property_address_state": "KS",
  "property_address_zip_full": null,
  "property_address_zip": "66219",
  "property_address_country": "US",
  "property_address_county": "Johnson County",
  "property_neighborhood_address": "Outlying Johnson County KS",
  "property_address_latitude": "38.9578329",
  "property_address_longitude": "-94.7814965",
  "property_email": "RentCafe.PK@PriceKC.com",
  "property_phone": "(913) 398-3018",
  "property_call_tracking_phone": "913-398-3018",
  "property_company_name": "Price Brothers",
  "property_company_url": "https://www.pricebrotherskc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Room to spread out, space to recharge.</strong> Explore Lenexa apartments and townhome-style layouts with polished finishes, attached-garage options, and resort-style community spaces—then schedule a tour to see Prairie Creek up close.</p>",
  "property_long_description": "<p>Prairie Creek Apartments &amp; Townhomes offers one-, two-, and three-bedroom <a href=\"/floor-plans\">apartments and townhomes for rent in Lenexa, KS</a>, located at 9395 Scarborough Street near 95th and Renner. The community is managed by Price Brothers Management, a Kansas City family-owned company since 1922.</p><p>Apartments feature 9-foot ceilings, stainless steel appliances, a kitchen prep island, and a full-size washer and dryer. Select homes add a den or study, a garden-size soaking tub, or an attached garage with direct access. Need more space? Our <a href=\"/floor-plans\">three-bedroom townhomes</a> offer more than 2,000 square feet.</p><p>Residents enjoy a saltwater swimming pool, an outdoor kitchen with a TV and fire pit, a 24-hour fitness center with a yoga room and on-site personal trainer, and monthly resident events. Prairie Creek is pet-friendly, with on-site walking trails for daily walks. Explore our <a href=\"/amenities\">community and apartment amenities</a>, browse the <a href=\"/gallery\">photo gallery</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> today.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b602-d185-7238-a32d-d44f535048ba.webp",
  "property_featured_image_media": {
    "alt_text": "Courtyard with fire pit and lounge chairs at sunset.",
    "public_id": "01a0b602-d185-7238-a32d-d44f535048ba",
    "storage_key": "property/6767906449167608/01a0b602-d185-7238-a32d-d44f535048ba.webp",
    "width": 800,
    "height": 600
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "425",
  "property_year_built": "2013",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "91.76470588235294",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $175-375",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.",
  "property_pet_policy_description": "The non-refundable fee is $300 for 1 pet, and $500 for 2 pets.",
  "property_petpolicy_info": "https://www.pricebrotherskc.com/petroyaltyclub/",
  "property_online_leasing_url": "https://prairiecreekapartments.securecafeapplicant.com/onlineleasing/content3/access/prairie-creek0/floorplans",
  "property_resident_portal_url": "https://prairiecreekapartments.securecafe.com/residentservices/prairie-creek0/userlogin.aspx",
  "property_apply_now_url": "https://prairiecreekapartments.securecafeapplicant.com/onlineleasing/content3/access/prairie-creek0/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b634-834c-7019-9af6-3dd4b67ad3d7.webp",
  "property_primary_logo_media": {
    "alt_text": "Prairie Creek Apartments & Townhomes logo",
    "public_id": "01a0b634-834c-7019-9af6-3dd4b67ad3d7",
    "storage_key": "property/6767906449167608/01a0b634-834c-7019-9af6-3dd4b67ad3d7.webp",
    "width": 112,
    "height": 60
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b634-834c-7019-9af6-3dd4b67ad3d7.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Prairie Creek Apartments & Townhomes logo",
    "public_id": "01a0b634-834c-7019-9af6-3dd4b67ad3d7",
    "storage_key": "property/6767906449167608/01a0b634-834c-7019-9af6-3dd4b67ad3d7.webp",
    "width": 112,
    "height": 60
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b634-c7db-7688-a323-34048718c034.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a0b634-c7db-7688-a323-34048718c034",
    "storage_key": "property/6767906449167608/01a0b634-c7db-7688-a323-34048718c034.webp",
    "width": 112,
    "height": 60
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a0d9b7-62d2-753a-a137-bd690ff6733b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff68a-de80-741a-9687-3e84c8c517e3.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#512A44",
  "property_secondary_color": "#A9431E",
  "property_font_color": null,
  "property_color_4": "#F6AE2D",
  "property_color_3": "#75787B",
  "property_color_5": "#A5C882",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2.5",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "704 - 2037",
  "property_sqft_min": "704",
  "property_sqft_max": "2037",
  "property_price_range": "1447 - 11453",
  "property_price_min": "1447",
  "property_price_max": "11453",
  "property_available_units": 35,
  "property_facebook_url": "https://www.facebook.com/PrairieCreekApts",
  "property_instagram_url": "https://www.instagram.com/prairiecreekapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJP5yCMm-UwIcR79-KL7tol3A",
  "property_youtube_url": "https://www.youtube.com/user/Pricebrothersmgt",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Prairie Creek Apartments & Townhomes",
  "property_home_romance_title": "Create Lasting Memories in Your Ideal Apartment Community",
  "property_home_amenities_blurb": "<p><strong>Amenities with room for more.</strong> Start with a workout or complimentary fitness class, unwind at the two-tiered saltwater infinity pool, then gather by the outdoor kitchen, TV, grills, and fire pit. The clubhouse adds business, billiards, coffee, and lounge spaces, while each apartment or townhome brings polished comforts like full-size laundry, stainless steel appliances, granite countertops, large closets, and private outdoor space.</p>",
  "property_home_floorplans_blurb": "<p>The townhomes at Prairie Creek Apartments &amp; Townhomes offer three bedrooms, an upstairs loft, an open-concept kitchen with living and dining areas, a spacious deck, and a finished lower-level bonus room with patio access. Every townhome includes an attached two-car garage and private driveway. <a href=\"/floor-plans\">Learn more about our townhomes</a>.</p>",
  "property_home_gallery_blurb": "<p><strong>Preview Prairie Creek in pictures.</strong> Browse bright kitchens with granite counters and stainless steel appliances, open living areas, roomy closets, and patios or balconies with fresh-air space. Then take in the community highlights: a two-tiered saltwater pool with sun shelf and waterfall, outdoor kitchen and fire pit, fitness and yoga spaces, clubhouse gathering areas, attached garages, and nature-view decks.</p>",
  "property_home_neighborhood_blurb": "<p>Prairie Creek Apartments &amp; Townhomes allows you to reach some of the area’s best destinations within minutes, putting the Lenexa City Center Public Market, the Lenexa Recreation Center, Brewbaker’s Bar &amp; Grill, and Shawnee Mission Park within a short drive. Nearby employers include Kiewit, Quest Diagnostics, and Grundfos, and on-site walking trails off Britton Street make it easy to get outside without leaving home. Visit our <a href=\"/neighborhood\">Neighborhood page</a> to see what’s nearby.</p>",
  "property_home_reviews_blurb": "<p><strong>Prairie Creek reviews say it best:</strong> residents highlight friendly service, quick maintenance, beautifully kept grounds, and homes that feel quiet, spacious, and well finished. From granite countertops and stainless steel appliances to generous storage, attached garages, and a relaxing pool area, the details stand out. Read more to see why one reviewer shared, “I truly feel like I have found my home.”</p>",
  "property_neighborhood_blurb": "<p>Prairie Creek Apartments &amp; Townhomes is located at 9395 Scarborough Street, Lenexa, KS 66219, near 95th and Renner. Lenexa City Center, the Lenexa Public Market, the Lenexa Rec Center, and Shawnee Mission Park are all minutes away.</p><p>Looking for a place to eat? Our team recommends Brewbaker’s Bar &amp; Grill, Silo Modern Farmhouse, Adrian’s Cafe for deli sandwiches, and KC Bier Co Lenexa for German-style beer.</p><p>Prairie Creek has on-site walking trails off Britton Street, and I-435 keeps commutes simple to Kiewit, Quest Diagnostics, Grundfos, and the greater Kansas City metro. Nearby public schools include Lenexa Hills Elementary, Westridge Middle School, and Shawnee Mission West High School.</p><p>Explore our <a href=\"/floor-plans\">floor plans</a> and <a href=\"/amenities\">amenities</a>, or <a href=\"/contact-us\">contact us</a> to schedule a tour.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Relax at the two-tiered swimming pool with a sun shelf and waterfall, gather at the outdoor kitchen with a TV and fire pit, or play basketball or tennis on the full-size sports court. The 24-hour fitness center and yoga room include free weights, complimentary fitness classes, and an on-site personal trainer.</p><p>Prairie Creek also has a media room, billiards, a tanning salon, a business center, Wi-Fi in common areas, a car wash, concierge services, and planned resident events. Attached one- and two-car garages are available in select apartments, and detached garages are available on request. Prairie Creek is a non-smoking community with flexible rent payment options.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Prairie Creek home?</strong> Choose a one-, two-, or three-bedroom apartment or townhome-style layout with polished finishes, spacious storage, and relaxing outdoor space. Explore available <a href=\"/floor-plans\">floor plans</a>, then start your online application with confidence.</p>",
  "property_contactus_blurb": "<p>Have a question about Prairie Creek Apartments &amp; Townhomes? Our team can help with <a href=\"/floor-plans\">floor plans</a>, pricing and availability, <a href=\"/amenities\">amenities and pet policies</a>, or setting up a tour.</p><p>Call us at <a href=\"tel:+19133983018\">(913) 398-3018</a>, visit the leasing office at 9395 Scarborough Street, Lenexa, KS 66219, or complete the form above. Office hours are Monday through Friday from 9:30 AM to 5:30 PM and Saturday from 10 AM to 5 PM.</p>",
  "property_faqs_blurb": "<p>Find answers to common questions about applying, pet policies, garages and parking, amenities, and tours at Prairie Creek Apartments &amp; Townhomes. You can also review our <a href=\"/floor-plans\">floor plans</a> and <a href=\"/amenities\">amenities</a> for more details.</p><p>If you don’t see the answer you need, <a href=\"/contact-us\">contact us</a>. Our leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p>Prairie Creek Apartments &amp; Townhomes offers one-, two-, and three-bedroom floor plans from 704 to 2,037 square feet, including three-bedroom townhomes. Every apartment includes 9-foot ceilings, stainless steel appliances, a full-size washer and dryer, and a deck. Select homes add a den or study, double sinks, a garden-size soaking tub, soft-close custom cabinets, plank flooring, or an attached one- or two-car garage with direct access.</p><ul><li><strong>One bedroom, one bath:</strong> Medina and Medina II (704 sq. ft.), Rio and Rio II (841 sq. ft.), Cimmaron and Cimmaron II (948 sq. ft.)</li><li><strong>Two bedroom, two bath:</strong> Sheyenne and Sheyenne II (1,090 sq. ft.), Cascade (1,210 sq. ft.), Savanna and Savanna II (1,372 sq. ft.)</li><li><strong>Three bedroom, two bath:</strong> Prairie and Prairie II (1,400 sq. ft.)</li><li><strong>Three-bedroom townhomes:</strong> Townhome (2,037 sq. ft.) and Townhome End Unit (2,002 sq. ft.)</li></ul><p>Compare finishes in Phase I and Phase II, take a look inside our townhomes, or choose a specific home on the interactive property map. Pets are welcome, so review our <a href=\"/amenities\">pet policy</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> of Prairie Creek Apartments &amp; Townhomes.</p>",
  "property_gallery_blurb": "<p>Browse photos of Prairie Creek Apartments &amp; Townhomes in Lenexa, KS, including apartment and townhome interiors, Phase I and Phase II kitchens, the two-tiered swimming pool, the outdoor kitchen and fire pit, the sports court, and the 24-hour fitness center.</p><p>Then compare our <a href=\"/floor-plans\">floor plans</a>, explore our <a href=\"/virtual-tours\">virtual tours</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_interactivemap_blurb": "<p>Use the Prairie Creek interactive property map to find available apartments and townhomes by building and location in the community. Filter by bedrooms, bathrooms, rent, square footage, and move-in date, then select a home to see its details.</p><p>Compare all <a href=\"/floor-plans\">floor plans</a>, review our <a href=\"/amenities\">amenities and pet policy</a>, or <a href=\"/contact-us\">contact us</a> with questions about pricing and availability.</p>",
  "property_pets_blurb": "<p>Prairie Creek Apartments &amp; Townhomes is a pet-friendly community that welcomes cats and dogs, with pet relief and walking areas on site and a nearby trail for daily walks.</p><ul><li><strong>Maximum pets:</strong> Two per home</li><li><strong>Monthly pet rent:</strong> $25 per pet</li><li><strong>Non-refundable pet fee:</strong> $300 for one pet or $500 for two pets</li></ul><p>Breed restrictions: Restricted breeds include Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and mixes that include any of these breeds. Management may restrict additional breeds. Exotic, feral, wild, or inherently dangerous animals are not permitted.</p><p>Prairie Creek Apartments &amp; Townhomes is a non-smoking community with flexible rent payment options. Ready to see it all in person? <a href=\"/schedule-a-tour\">Schedule a tour</a> today.</p>",
  "property_referafriend_blurb": "<p><strong>Share the space, style, and everyday ease you love.</strong> Invite a friend to discover Prairie Creek’s roomy <a href=\"/floor-plans\">apartments and townhome-style layouts</a>, polished finishes, attached garage options, and high-amenity spaces made for recharging. Send a referral today and let them see why this Lenexa community feels so easy to recommend.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Prairie Creek.</strong><br>Pay rent, submit maintenance requests, and manage your account in one easy place—so you can get back to enjoying your Lenexa home, from spacious layouts and polished finishes to the community spaces that make recharging simple.</p>",
  "property_reviews_blurb": "<p>See what residents say about living at Prairie Creek Apartments &amp; Townhomes in Lenexa, KS. Browse ratings by category and read reviews about our leasing team, apartment homes, townhomes, and community amenities.</p><p>Want to experience it for yourself? Compare our <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> today.</p>",
  "property_created_at": "1785792350274",
  "property_scheduletour_blurb": "<p>Book a guided tour with the Prairie Creek leasing team to walk through apartment and townhome interiors and community spaces. Select the number of bedrooms you’re interested in, pick a date and time, and confirm your visit. Prefer to look on your own first? Take a <a href=\"/virtual-tours\">virtual tour</a>.</p><p>The leasing office at 9395 Scarborough Street, Lenexa, KS 66219, is open Monday through Friday from 9:30 a.m. to 5:30 p.m. and Saturday from 10 a.m. to 5 p.m., and is closed Sunday.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong><br>The Prairie Creek leasing team will follow up soon. In the meantime, picture a Lenexa home with room to spread out, polished finishes, spacious layouts, and places to recharge—from large patios or balconies to a two-tiered saltwater pool and inviting community spaces.</p>",
  "property_virtualtours_blurb": "<p>Explore Prairie Creek Apartments &amp; Townhomes from anywhere with 360 virtual tours of our apartment and townhome floor plans. Move through each layout at your own pace to see how the kitchen, living areas, and bedrooms connect.</p><ul><li><strong>Phase I:</strong> Medina, Rio, Cimmaron, Cascade, Sheyenne, Savanna, and Prairie</li><li><strong>Phase II:</strong> Medina II, Rio II, Cimmaron II, Sheyenne II, Savanna II, and Prairie II</li><li><strong>Townhomes:</strong> Three-Bedroom End Unit Townhome</li></ul><p>Review square footage and finishes on our <a href=\"/floor-plans\">floor plans page</a>, or <a href=\"/schedule-a-tour\">schedule a guided tour</a> to see Prairie Creek Apartments &amp; Townhomes in person.</p>",
  "property_copyright": "2026 All Rights Reserved. Prairie Creek Apartments & Townhomes",
  "property_seo_title_home": "Prairie Creek Apartments & Townhomes | Lenexa, KS",
  "property_seo_description_home": "Prairie Creek Apartments & Townhomes offers 1, 2 & 3-bedroom apartments and townhomes for rent in Lenexa, KS, near 95th and Renner. Tour today!",
  "property_seo_title_floorplans": "1, 2 & 3-Bed Apartments in Lenexa, KS | Prairie Creek",
  "property_seo_description_floorplans": "Compare 1, 2 & 3-bedroom apartments and townhomes at Prairie Creek Apartments & Townhomes in Lenexa, KS, from 704 to 2,037 square feet.",
  "property_seo_title_amenities": "Luxury Apartment Amenities in Lenexa | Prairie Creek",
  "property_seo_description_amenities": "See the amenities at Prairie Creek Apartments & Townhomes in Lenexa, KS, including a pool, 24-hour fitness center, sports court, and pet-friendly homes.",
  "property_seo_title_gallery": "Photos | Prairie Creek Apartments & Townhomes",
  "property_seo_description_gallery": "Browse photos of Prairie Creek Apartments & Townhomes in Lenexa, KS, including apartment interiors, townhomes, the pool, and the fitness center.",
  "property_seo_title_virtualtours": "Apartment Virtual Tours in Lenexa, KS | Prairie Creek",
  "property_seo_description_virtualtours": "Take a virtual tour of Phase I, Phase II, and townhome floor plans at Prairie Creek Apartments & Townhomes in Lenexa, KS, before you visit.",
  "property_seo_title_interactivemap": "Interactive Property Map | Prairie Creek Apartments",
  "property_seo_description_interactivemap": "Use the interactive property map at Prairie Creek Apartments & Townhomes to find an available apartment or townhome in Lenexa, KS, and apply online.",
  "property_seo_title_neighborhood": "Apartments Near Lenexa City Center | Prairie Creek",
  "property_seo_description_neighborhood": "Prairie Creek Apartments & Townhomes is near 95th and Renner in Lenexa, KS, minutes from Lenexa City Center, Shawnee Mission Park, and Oak Park Mall.",
  "property_seo_title_contact": "Contact Prairie Creek Apartments & Townhomes",
  "property_seo_description_contact": "Contact Prairie Creek Apartments & Townhomes in Lenexa, KS, to ask about floor plans, pricing, availability, or scheduling a tour.",
  "property_seo_title_faqs": "FAQs | Prairie Creek Apartments & Townhomes",
  "property_seo_description_faqs": "Find answers about leasing, pets, parking, amenities, and tours at Prairie Creek Apartments & Townhomes in Lenexa, KS.",
  "property_seo_title_reviews": "Reviews | Prairie Creek Apartments & Townhomes",
  "property_seo_description_reviews": "Read resident reviews and ratings for Prairie Creek Apartments & Townhomes in Lenexa, KS, and see what residents say about our community.",
  "property_seo_title_applynow": "Apply Now | Apartments in Lenexa, KS",
  "property_seo_description_applynow": "Unwind at Prairie Creek Apartments & Townhomes in Lenexa, KS. Enjoy luxury amenities, spacious layouts, and a vibrant community. Lease your dream home today!",
  "property_seo_title_residentaccess": "Resident Access | Prairie Creek Apartments & Townhomes",
  "property_seo_description_residentaccess": "Seamlessly manage your home at Prairie Creek Apartments & Townhomes. Log in to pay rent, schedule maintenance, and enjoy hassle-free living in Lenexa, KS!",
  "property_seo_title_referafriend": "Refer A Friend | Prairie Creek Apartments & Townhomes",
  "property_seo_description_referafriend": "Invite your friends to Prairie Creek Apartments & Townhomes in Lenexa, KS! Share the joy of great living and enjoy community perks together. Refer now!",
  "property_seo_title_scheduletour": "Schedule a Tour | Prairie Creek Apartments & Townhomes",
  "property_seo_description_scheduletour": "Schedule a guided or 360 tour of Prairie Creek Apartments & Townhomes in Lenexa, KS, and see our 1, 2 & 3-bedroom apartments and townhomes.",
  "property_seo_title_privacy": "Privacy Policy | Prairie Creek Apartments & Townhomes",
  "property_seo_description_privacy": "Protecting your peace of mind at Prairie Creek Apartments & Townhomes in Lenexa, KS. Read our privacy policy to learn how we safeguard your information.",
  "property_seo_title_accessibility": "Website Accessibility | Prairie Creek Apartments & Townhomes",
  "property_seo_description_accessibility": "Elevate your living experience at Prairie Creek Apartments & Townhomes in Lenexa, KS. We prioritize accessibility and digital inclusion for everyone.",
  "property_seo_title_sitemap": "Sitemap | Prairie Creek Apartments & Townhomes",
  "property_seo_description_sitemap": "Navigate your way through Prairie Creek Apartments & Townhomes in Lenexa, KS. Find everything you need with our detailed sitemap. Your new home awaits!",
  "property_seo_title_thankyou": "Thank You | Prairie Creek Apartments & Townhomes",
  "property_seo_description_thankyou": "Thank you for reaching out to Prairie Creek Apartments & Townhomes in Lenexa, KS! Our team will connect with you soon to discuss your ideal living experience.",
  "property_seo_title_pets": "Pet Policy | Apartments in Lenexa, KS",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793628870877",
  "amenities": [
    {
      "id": "ec_0eb087cee25667066f4012fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "87572019",
      "title": "Two-Tiered Swimming Pool with Sun Shelf & Waterfall",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b602-f7d3-734b-b1d3-ea2598e10550.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool with a waterfall feature and lounge chairs.",
        "public_id": "01a0b602-f7d3-734b-b1d3-ea2598e10550",
        "storage_key": "property/6767906449167608/01a0b602-f7d3-734b-b1d3-ea2598e10550.webp",
        "width": 800,
        "height": 600
      },
      "amenity_image_alt_text": "a large swimming pool with a building in the background at Prairie Creek Apartments & Townhomes Apartments, Kansas, 66219,the swimming pool at the apartments for rent at Prairie Creek Apartments & Townhomes Apartments, Kansas,a large swimming pool with a building in the background at Prairie Creek Apartments & Townhomes Apartments, Lenexa",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3382d36f3f30fc6074ae4715",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "87572011",
      "title": "Full-Size Sports Court for Basketball & Tennis",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc986-5afd-743f-8026-56567f1046f1.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor basketball court with modern apartment buildings in the background.",
        "public_id": "019fc986-5afd-743f-8026-56567f1046f1",
        "storage_key": "property/6767906449167608/019fc986-5afd-743f-8026-56567f1046f1.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Play at Prairie Creek Apartments & Townhomes, Lenexa, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_66413a1ace8e9c6d2a9bb785",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "87572016",
      "title": "Fitness Center & Yoga Room",
      "amount": "false",
      "description": "24 Hour Resident Access",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b602-f84b-721a-84c0-39a422a9c54e.webp",
      "amenity_image_media": {
        "alt_text": "Spacious community room with herringbone patterned carpet and a television mounted on the wall.",
        "public_id": "01a0b602-f84b-721a-84c0-39a422a9c54e",
        "storage_key": "property/6767906449167608/01a0b602-f84b-721a-84c0-39a422a9c54e.webp",
        "width": 800,
        "height": 600
      },
      "amenity_image_alt_text": "a living room with a tv and a door to a hallway at Prairie Creek Apartments & Townhomes Apartments, Lenexa, Kansas,an empty living room with a tv and windows at Prairie Creek Apartments & Townhomes Apartments, Lenexa 66219,a gym with treadmills and other exercise equipment  at Prairie Creek Apartments & Townhomes, Kansas,Fitness 1 at Prairie Creek Apartments & Townhomes, Lenexa,Gym areaat Prairie Creek Apartments & Townhomes, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bc92e40cd600dde49d480565",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "118172357",
      "title": "Free Weights",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fa135528de452a618298e4ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "87572013",
      "title": "Business Center with Computers, Printer & Fax",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b602-df94-70db-9883-8d6e2710b0b1.webp",
      "amenity_image_media": {
        "alt_text": "Business center with two workstations, printers, and office chairs.",
        "public_id": "01a0b602-df94-70db-9883-8d6e2710b0b1",
        "storage_key": "property/6767906449167608/01a0b602-df94-70db-9883-8d6e2710b0b1.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Home decor at Prairie Creek Apartments & Townhomes, Kansas, 66219",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6e2138495e3e25f2349b7954",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "87572026",
      "title": "WiFi in Common areas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fb08c1e74120d672f389d33b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "118172360",
      "title": "Media Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9c61c3f2ed748fa99700554c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "87572014",
      "title": "Concierge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8131c0d392a98513d6adc1fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "87584307",
      "title": "Outdoor Grilling area with Kitchen, TV & Fire Pit",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b602-f818-74af-b1c7-5756fcd41f9d.webp",
      "amenity_image_media": {
        "alt_text": "Community fire pit and pool area at dusk.",
        "public_id": "01a0b602-f818-74af-b1c7-5756fcd41f9d",
        "storage_key": "property/6767906449167608/01a0b602-f818-74af-b1c7-5756fcd41f9d.webp",
        "width": 800,
        "height": 600
      },
      "amenity_image_alt_text": "a patio with chairs and a fire pit at Prairie Creek Apartments & Townhomes Apartments, Lenexa, KS,a large outdoor kitchen with a bar and a fireplace at Prairie Creek Apartments & Townhomes Apartments, Lenexa, KS, 66219",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_064061a7cc6a619faf02083f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "87584302",
      "title": "Personal Trainer",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_acf99163e1a932b7eeb204f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "87584310",
      "title": "Complimentary Fitness Classes",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f16cbf60ee7e7854a0789f3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "87584301",
      "title": "Tanning Salon",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bf1abd2be50fcef703c9ff3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "87572020",
      "title": "Billiards",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b602-f807-744e-8da0-bafed9df608f.webp",
      "amenity_image_media": {
        "alt_text": "Community room with pool table, seating area, and TV.",
        "public_id": "01a0b602-f807-744e-8da0-bafed9df608f",
        "storage_key": "property/6767906449167608/01a0b602-f807-744e-8da0-bafed9df608f.webp",
        "width": 800,
        "height": 600
      },
      "amenity_image_alt_text": "a living room with a pool table and a tv at Prairie Creek Apartments & Townhomes Apartments, Lenexa 66219",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a44627f075d88475d1374f77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "87572091",
      "title": "Car Wash",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-0014-76ad-8051-c7b5d65c72a4.webp",
      "amenity_image_media": {
        "alt_text": "Attached garage and carport for a residential unit.",
        "public_id": "01a0b603-0014-76ad-8051-c7b5d65c72a4",
        "storage_key": "property/6767906449167608/01a0b603-0014-76ad-8051-c7b5d65c72a4.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Exterior view1 at Prairie Creek Apartments & Townhomes, Lenexa, 66219",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4a3d74b4c435a4087f5b1f19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "121191785",
      "title": "Planned Resident Events",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_87524475a000efa881a7b1ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "87584299",
      "title": "Nearby Trail",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3b7d1fd4195b84f3dcbb34ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "121191784",
      "title": "Pet Relief and Walking Areas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b33e14201192fdbfae3d2472",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "87572021",
      "title": "Non-Smoking Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e73c5b0837b75c91555dad7f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "122755389",
      "title": "Flexible Rent Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cd0d4daa0cfb3195f79ddd0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "121191783",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_26207985ffd40d25df130a54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "121191782",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_be379a5f8cbe0edaefa2a1ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "87572192",
      "title": "Side-by-side Refrigerator with Ice Maker",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d6697dda51890a1070b28a32",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "87572087",
      "title": "Full-size Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6748358fbabcd98d8d34b3e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "87572068",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_24b78f97ecbafff8295bfcf2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "87572053",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_96a8c525261e6e0148b7dfa3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "87572049",
      "title": "Large Outdoor Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-0046-70a9-897b-282cb3d3e02e.webp",
      "amenity_image_media": {
        "alt_text": "Balcony with outdoor furniture and view of apartment buildings and lawn.",
        "public_id": "01a0b603-0046-70a9-897b-282cb3d3e02e",
        "storage_key": "property/6767906449167608/01a0b603-0046-70a9-897b-282cb3d3e02e.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A balcony with a table and chairs overlooks a house and a lawn at Prairie Creek Apartments & Townhomes Apartments, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_489d0880ed5fc0a7c08fec1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "87572048",
      "title": "9 ft Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cf010fc1bebb9c4abe9d3438",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "87572056",
      "title": "Stainless Steel Appliance Package",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-0083-754d-9c17-64979be85cc9.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and an island.",
        "public_id": "01a0b603-0083-754d-9c17-64979be85cc9",
        "storage_key": "property/6767906449167608/01a0b603-0083-754d-9c17-64979be85cc9.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A modern kitchen with a stainless steel refrigerator and wooden cabinets at Prairie Creek Apartments & Townhomes Apartments, Lenexa, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f2f96817f9728047dfe7707e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "87572089",
      "title": "Gourmet Prep Island",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-176d-750b-9623-25f45bbc694a.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and bar seating.",
        "public_id": "01a0b603-176d-750b-9623-25f45bbc694a",
        "storage_key": "property/6767906449167608/01a0b603-176d-750b-9623-25f45bbc694a.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A modern kitchen with a refrigerator, microwave, and stove top oven at Prairie Creek Apartments & Townhomes Apartments, Lenexa",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f415b88c97684549a7f0c789",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "87572052",
      "title": "Faux Wood Blinds",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e4a5f4e0d4276fee49c839ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "87572055",
      "title": "Spacious Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_24e4e433920efc0d76bfb9b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "87572071",
      "title": "Den/Study*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_54d83c3842631b8c1995caa0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "87572083",
      "title": "Double Sinks in Main Bathroom*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9e0f91fdb163f575dd761b43",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "87583963",
      "title": "Garden Size Soaking Tub*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_596c3fff10c0b1cdf3119c48",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "118172370",
      "title": "Soft Close Cabinets & Drawers*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_403ec26563a49b04ae71d8aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "118172405",
      "title": "Attached One & Two Car Garages*",
      "amount": "false",
      "description": "1 & 2 Car garages with direct access into select apartments. 2 Car garages included on all townhomes. Detached garages are available upon request.",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_471f90874dfd7cf7ac5ae181",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "122020585",
      "title": "Plank Flooring*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7c782206e4b35daa0f229694",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "external_id": "126424847",
      "title": "Cul-de-sac*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_103c815f803e39ef30bf73bb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b602-d185-7238-a32d-d44f535048ba.webp",
      "image_media": {
        "alt_text": "Courtyard with fire pit and lounge chairs at sunset.",
        "public_id": "01a0b602-d185-7238-a32d-d44f535048ba",
        "storage_key": "property/6767906449167608/01a0b602-d185-7238-a32d-d44f535048ba.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Relax by the fire pit in our beautiful courtyard, featuring comfortable lounge chairs and a swimming pool area. Enjoy the sunset at this inviting community space.",
      "link": "false",
      "alt_text": "Courtyard with fire pit and lounge chairs at sunset.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/15-DSC06081-VT.jpg"
    },
    {
      "id": "ec_3ccc13bafeb64f360182fa4c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc985-f364-749f-9c44-3e58772a2799.webp",
      "image_media": {
        "alt_text": "Row of townhouses with attached garages and manicured lawns under a cloudy sky.",
        "public_id": "019fc985-f364-749f-9c44-3e58772a2799",
        "storage_key": "property/6767906449167608/019fc985-f364-749f-9c44-3e58772a2799.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Exterior view of modern townhomes featuring dual-tone exteriors, brick accents, and attached garages, set within a well-maintained community landscape.",
      "link": "false",
      "alt_text": "Row of townhouses with attached garages and manicured lawns under a cloudy sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/IMG_7816.jpg"
    },
    {
      "id": "ec_6a47ab6c6a40ff356f71dcfe",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-2227-76c7-9f41-4a3591ab07e8.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with a waterfall feature and lounge chairs.",
        "public_id": "01a0b603-2227-76c7-9f41-4a3591ab07e8",
        "storage_key": "property/6767906449167608/01a0b603-2227-76c7-9f41-4a3591ab07e8.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning resort-style swimming pool, complete with a soothing waterfall and ample lounge seating for relaxation.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with a waterfall feature and lounge chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12-DSC05936.jpg"
    },
    {
      "id": "ec_138491a7150fbec3ba48ddbf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-2232-7616-bbc0-3dd6d7742eac.webp",
      "image_media": {
        "alt_text": "Spacious open-concept living and dining area with a modern kitchen.",
        "public_id": "01a0b603-2232-7616-bbc0-3dd6d7742eac",
        "storage_key": "property/6767906449167608/01a0b603-2232-7616-bbc0-3dd6d7742eac.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Enjoy a bright and airy open-concept living space, perfect for entertaining, with a gourmet kitchen featuring ample counter space and stylish bar seating.",
      "link": "false",
      "alt_text": "Spacious open-concept living and dining area with a modern kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/39-9395 Scarborough St -30_final.jpg"
    },
    {
      "id": "ec_530622b182674d0cbcb9b887",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-36f6-70fe-a6a3-9e082900db1c.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
        "public_id": "01a0b603-36f6-70fe-a6a3-9e082900db1c",
        "storage_key": "property/6767906449167608/01a0b603-36f6-70fe-a6a3-9e082900db1c.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious and updated kitchen featuring stainless steel appliances, granite countertops, and ample cabinet space, perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/41-9395 Scarborough St -31_final.jpg"
    },
    {
      "id": "ec_6abb4893d7116e9a3509ea53",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-2289-70c9-9242-3edd8caf6d42.webp",
      "image_media": {
        "alt_text": "Kitchen with stainless steel appliances, granite countertops, and island with bar stools.",
        "public_id": "01a0b603-2289-70c9-9242-3edd8caf6d42",
        "storage_key": "property/6767906449167608/01a0b603-2289-70c9-9242-3edd8caf6d42.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring stainless steel appliances, ample cabinet space, granite countertops, and a spacious island perfect for casual dining.",
      "link": "false",
      "alt_text": "Kitchen with stainless steel appliances, granite countertops, and island with bar stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/33-9395 Scarborough St -25_final.jpg"
    },
    {
      "id": "ec_ad7783b6268fca9addc66baf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-2a24-7600-b764-91ad4d226320.webp",
      "image_media": {
        "alt_text": "Bathroom with dark wood vanity, granite countertop, modern mirror, and toilet.",
        "public_id": "01a0b603-2a24-7600-b764-91ad4d226320",
        "storage_key": "property/6767906449167608/01a0b603-2a24-7600-b764-91ad4d226320.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a dark wood double vanity with a granite countertop, a large modern mirror, and a toilet. The adjacent hallway offers a glimpse of the kitchen area.",
      "link": "false",
      "alt_text": "Bathroom with dark wood vanity, granite countertop, modern mirror, and toilet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/50-9395 Scarborough St -37_final.jpg"
    },
    {
      "id": "ec_014acb6c0e370441e1ceac5f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-2b81-77da-8606-c2091f9424e2.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, dresser, and an en-suite bathroom.",
        "public_id": "01a0b603-2b81-77da-8606-c2091f9424e2",
        "storage_key": "property/6767906449167608/01a0b603-2b81-77da-8606-c2091f9424e2.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed, elegant dresser, and access to an en-suite bathroom and closet.",
      "link": "false",
      "alt_text": "Bedroom with a bed, dresser, and an en-suite bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/44-9395 Scarborough St -33_final.jpg"
    },
    {
      "id": "ec_9cfbd940ef09ab359831321a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-2d36-7599-8b1c-5377aad72005.webp",
      "image_media": {
        "alt_text": "Modern bathroom with walk-in shower, vanity, and dark wood cabinets.",
        "public_id": "01a0b603-2d36-7599-8b1c-5377aad72005",
        "storage_key": "property/6767906449167608/01a0b603-2d36-7599-8b1c-5377aad72005.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Step into this beautiful bathroom featuring a spacious walk-in shower, elegant vanity with granite countertops, and ample storage in dark wood cabinets.",
      "link": "false",
      "alt_text": "Modern bathroom with walk-in shower, vanity, and dark wood cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/47-9395 Scarborough St -35_final.jpg"
    },
    {
      "id": "ec_4d40fefcbdf597e6e63f4e5d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-46ae-7157-9e21-d47e9cecc1fa.webp",
      "image_media": {
        "alt_text": "Open-concept living area with dining table, kitchen, and dedicated workspace.",
        "public_id": "01a0b603-46ae-7157-9e21-d47e9cecc1fa",
        "storage_key": "property/6767906449167608/01a0b603-46ae-7157-9e21-d47e9cecc1fa.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious open-concept apartment featuring a modern kitchen, a comfortable living area, and a built-in workspace for your convenience.",
      "link": "false",
      "alt_text": "Open-concept living area with dining table, kitchen, and dedicated workspace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/01-9395 Scarborough St -1_final.jpg"
    },
    {
      "id": "ec_550c1d23a48f322d7515085f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-33bd-7525-9c90-5ba5d058b7e4.webp",
      "image_media": {
        "alt_text": "Modern apartment living room with open-concept kitchen, dining area, and a home office nook.",
        "public_id": "01a0b603-33bd-7525-9c90-5ba5d058b7e4",
        "storage_key": "property/6767906449167608/01a0b603-33bd-7525-9c90-5ba5d058b7e4.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment featuring an open-concept living area, fully equipped kitchen with island, a dedicated dining space, and a convenient home office nook.",
      "link": "false",
      "alt_text": "Modern apartment living room with open-concept kitchen, dining area, and a home office nook.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/04-9395 Scarborough St -3_final.jpg"
    },
    {
      "id": "ec_8ea680ce034794cd76591778",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-365f-770b-be2b-ee558d574c7e.webp",
      "image_media": {
        "alt_text": "Bedroom with a ceiling fan and a large dresser featuring a mirror and decorative items.",
        "public_id": "01a0b603-365f-770b-be2b-ee558d574c7e",
        "storage_key": "property/6767906449167608/01a0b603-365f-770b-be2b-ee558d574c7e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan, a comfortable bed with accent blankets, and a stylish dresser with decorative accents and a unique mirror.",
      "link": "false",
      "alt_text": "Bedroom with a ceiling fan and a large dresser featuring a mirror and decorative items.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/15-9395 Scarborough St -11_final.jpg"
    },
    {
      "id": "ec_12263d30dec872b6545f58db",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-3cdb-72e6-b345-8f241c04fc84.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with dark wood cabinets, granite countertop, and a large framed mirror.",
        "public_id": "01a0b603-3cdb-72e6-b345-8f241c04fc84",
        "storage_key": "property/6767906449167608/01a0b603-3cdb-72e6-b345-8f241c04fc84.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Elegant bathroom featuring a spacious vanity with ample storage, granite countertops, and a large mirror. Includes a toilet and decorative artwork.",
      "link": "false",
      "alt_text": "Modern bathroom vanity with dark wood cabinets, granite countertop, and a large framed mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/28-9395 Scarborough St -22_final.jpg"
    },
    {
      "id": "ec_b62bdacfd94d541bd349f72b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-3ef1-7321-9e09-f7ba4e3e9863.webp",
      "image_media": {
        "alt_text": "Modern bathroom with granite countertop, dark wood vanity, toilet, and bathtub with decorative shower curtain.",
        "public_id": "01a0b603-3ef1-7321-9e09-f7ba4e3e9863",
        "storage_key": "property/6767906449167608/01a0b603-3ef1-7321-9e09-f7ba4e3e9863.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this well-appointed bathroom, featuring a granite vanity, ample storage, and a relaxing bathtub.",
      "link": "false",
      "alt_text": "Modern bathroom with granite countertop, dark wood vanity, toilet, and bathtub with decorative shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/19-9395 Scarborough St -14_final.jpg"
    },
    {
      "id": "ec_bf8f8bd9cc5c4cc9f594cfe2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-55fc-7468-8b9f-047153f81134.webp",
      "image_media": {
        "alt_text": "Open concept living and kitchen area with a large island, sofa, and dining table.",
        "public_id": "01a0b603-55fc-7468-8b9f-047153f81134",
        "storage_key": "property/6767906449167608/01a0b603-55fc-7468-8b9f-047153f81134.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Enjoy the spacious open-concept living and kitchen area, perfect for entertaining. Features a large kitchen island, modern appliances, and a comfortable living space.",
      "link": "false",
      "alt_text": "Open concept living and kitchen area with a large island, sofa, and dining table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/11-9395 Scarborough St -8-_final.jpg"
    },
    {
      "id": "ec_1b3e3cec0c8c16f1a16f287b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-5619-7076-8900-092da78401fb.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a breakfast bar.",
        "public_id": "01a0b603-5619-7076-8900-092da78401fb",
        "storage_key": "property/6767906449167608/01a0b603-5619-7076-8900-092da78401fb.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment kitchen featuring granite countertops, stainless steel appliances, ample cabinet space, and a convenient breakfast bar. Perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a breakfast bar.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/07-9395 Scarborough St -5_final.jpg"
    },
    {
      "id": "ec_8b6389acc29fc95005cb0b5f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-4575-7378-841a-c89718cec5f0.webp",
      "image_media": {
        "alt_text": "Balcony with seating and view of apartment buildings",
        "public_id": "01a0b603-4575-7378-841a-c89718cec5f0",
        "storage_key": "property/6767906449167608/01a0b603-4575-7378-841a-c89718cec5f0.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Enjoy your private balcony, perfect for relaxing and taking in the views of the community.",
      "link": "false",
      "alt_text": "Balcony with seating and view of apartment buildings",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/30-9395 Scarborough St -23_final.jpg"
    },
    {
      "id": "ec_4d9b099dbcc65750c094b005",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-49a9-712f-953f-04e4805a72a5.webp",
      "image_media": {
        "alt_text": "Living room with sofa and dining area next to kitchen.",
        "public_id": "01a0b603-49a9-712f-953f-04e4805a72a5",
        "storage_key": "property/6767906449167608/01a0b603-49a9-712f-953f-04e4805a72a5.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "A spacious living area featuring a comfortable sofa, a dining table with chairs, and a modern kitchen with granite countertops and stainless steel appliances.",
      "link": "false",
      "alt_text": "Living room with sofa and dining area next to kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Prairie Creek - 04 - Staged(2).jpg"
    },
    {
      "id": "ec_851e709ca59e4968c3a2a24d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-6654-7637-b514-940173f0cd6d.webp",
      "image_media": {
        "alt_text": "Living room with sofa, chairs, coffee table, and kitchen in the background.",
        "public_id": "01a0b603-6654-7637-b514-940173f0cd6d",
        "storage_key": "property/6767906449167608/01a0b603-6654-7637-b514-940173f0cd6d.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious living area featuring comfortable seating, a TV, and an open-concept kitchen perfect for entertaining.",
      "link": "false",
      "alt_text": "Living room with sofa, chairs, coffee table, and kitchen in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Prairie Creek - 03 - Staged(2).jpg"
    },
    {
      "id": "ec_0b99fb08344864c6b2ace602",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc986-081e-745c-b316-98a3fed0169f.webp",
      "image_media": {
        "alt_text": "Bathroom with double vanity, granite countertops, and toilet.",
        "public_id": "019fc986-081e-745c-b316-98a3fed0169f",
        "storage_key": "property/6767906449167608/019fc986-081e-745c-b316-98a3fed0169f.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with granite countertops, ample cabinet storage, and a private toilet area. Perfect for a relaxing retreat.",
      "link": "false",
      "alt_text": "Bathroom with double vanity, granite countertops, and toilet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/IMG_7653-HDR.jpg"
    },
    {
      "id": "ec_abc904c89baf2b0bd3c3e01f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-54b2-70cb-8c36-2e8b02933c82.webp",
      "image_media": {
        "alt_text": "A king-size bed with a padded headboard and plush bedding, a ceiling fan, and a window view of houses.",
        "public_id": "01a0b603-54b2-70cb-8c36-2e8b02933c82",
        "storage_key": "property/6767906449167608/01a0b603-54b2-70cb-8c36-2e8b02933c82.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king-size bed, comfortable bedding, a ceiling fan for circulation, and ample natural light from the window.",
      "link": "false",
      "alt_text": "A king-size bed with a padded headboard and plush bedding, a ceiling fan, and a window view of houses.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Prairie Creek - 07 - Staged(1).jpg"
    },
    {
      "id": "ec_ec64b1579c16cfee241e0618",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-75ac-7199-96ed-dd7fa267e6c2.webp",
      "image_media": {
        "alt_text": "Bedroom with walk-in closet and access to bathroom and office area",
        "public_id": "01a0b603-75ac-7199-96ed-dd7fa267e6c2",
        "storage_key": "property/6767906449167608/01a0b603-75ac-7199-96ed-dd7fa267e6c2.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a walk-in closet, ceiling fan, and plush carpeting. Enjoy convenient access to a private bathroom and a dedicated office space.",
      "link": "false",
      "alt_text": "Bedroom with walk-in closet and access to bathroom and office area",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Prairie Creek - 08 - Staged(1).jpg"
    },
    {
      "id": "ec_ebde3e606775ccc1c32624de",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-5f51-750d-98a0-347fff864186.webp",
      "image_media": {
        "alt_text": "Recreational room with a pool table, guitar, and vintage motorcycle art.",
        "public_id": "01a0b603-5f51-750d-98a0-347fff864186",
        "storage_key": "property/6767906449167608/01a0b603-5f51-750d-98a0-347fff864186.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Enjoy downtime in the recreational room, complete with a pool table, entertainment area, and decorative art.",
      "link": "false",
      "alt_text": "Recreational room with a pool table, guitar, and vintage motorcycle art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Prairie Creek - 15 - Staged(1).jpg"
    },
    {
      "id": "ec_32afdecb7dcca141623d5120",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-5f78-72c6-9b99-2f6b933043b6.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, dresser, and closet.",
        "public_id": "01a0b603-5f78-72c6-9b99-2f6b933043b6",
        "storage_key": "property/6767906449167608/01a0b603-5f78-72c6-9b99-2f6b933043b6.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king-size bed with a dark green throw, a modern dresser, and a walk-in closet with organized clothing. The room is decorated with abstract art and has a ceiling fan.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, dresser, and closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Prairie Creek - 11 - Staged(1).jpg"
    },
    {
      "id": "ec_e0d29a79b903bc3be2795c2f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-7d91-726c-9701-829c460aa223.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, ceiling fan, and large window.",
        "public_id": "01a0b603-7d91-726c-9701-829c460aa223",
        "storage_key": "property/6767906449167608/01a0b603-7d91-726c-9701-829c460aa223.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush queen-size bed, a modern ceiling fan for your comfort, and ample natural light from the large window.",
      "link": "false",
      "alt_text": "Cozy bedroom with a queen-size bed, ceiling fan, and large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Prairie Creek - 10 - Staged(1).jpg"
    },
    {
      "id": "ec_a06e613453977e3bb226f174",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-69dd-701e-8414-a95bea46bf34.webp",
      "image_media": {
        "alt_text": "Living room with a large sectional sofa, entertainment center with a TV, and a popcorn bowl.",
        "public_id": "01a0b603-69dd-701e-8414-a95bea46bf34",
        "storage_key": "property/6767906449167608/01a0b603-69dd-701e-8414-a95bea46bf34.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Relax in this stylish living room featuring a comfortable sectional sofa, a modern entertainment center with a large TV, and decorative accents. Perfect for movie nights or entertaining guests.",
      "link": "false",
      "alt_text": "Living room with a large sectional sofa, entertainment center with a TV, and a popcorn bowl.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Prairie Creek - 14 - Staged(1).jpg"
    },
    {
      "id": "ec_d699fb4e8af659d0e8fb5570",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-6cfb-7317-8c15-208a80853edf.webp",
      "image_media": {
        "alt_text": "A home office space with a desk, chair, and shelves.",
        "public_id": "01a0b603-6cfb-7317-8c15-208a80853edf",
        "storage_key": "property/6767906449167608/01a0b603-6cfb-7317-8c15-208a80853edf.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Create your ideal workspace in this dedicated home office area, featuring a stylish desk and ample shelving for all your essentials.",
      "link": "false",
      "alt_text": "A home office space with a desk, chair, and shelves.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Prairie Creek - 06 - Staged(2).jpg"
    },
    {
      "id": "ec_4acab25a6cb57302011e4ee9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-854c-70fd-bebe-590c2ede2ca0.webp",
      "image_media": {
        "alt_text": "Living room with TV, entertainment center, and sectional sofa.",
        "public_id": "01a0b603-854c-70fd-bebe-590c2ede2ca0",
        "storage_key": "property/6767906449167608/01a0b603-854c-70fd-bebe-590c2ede2ca0.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a mounted TV, sleek entertainment center, and comfortable sectional sofa, perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Living room with TV, entertainment center, and sectional sofa.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Prairie Creek - 14 - Staged(2).jpg"
    },
    {
      "id": "ec_163f6a860f82214675974b18",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc986-2200-71c8-b3b9-cf7d28271962.webp",
      "image_media": {
        "alt_text": "Exterior of a duplex with two attached garages.",
        "public_id": "019fc986-2200-71c8-b3b9-cf7d28271962",
        "storage_key": "property/6767906449167608/019fc986-2200-71c8-b3b9-cf7d28271962.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Beautifully maintained duplex with two spacious garages, offering ample parking and storage space for residents.",
      "link": "false",
      "alt_text": "Exterior of a duplex with two attached garages.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/IMG_7425.jpg"
    },
    {
      "id": "ec_8f3406a3a70f92dbff00fff3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc986-1a15-725c-9266-35c7d1e72b97.webp",
      "image_media": {
        "alt_text": "Empty garage with automatic door opener.",
        "public_id": "019fc986-1a15-725c-9266-35c7d1e72b97",
        "storage_key": "property/6767906449167608/019fc986-1a15-725c-9266-35c7d1e72b97.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Spacious and clean garage with an automatic door opener, ready for your vehicle.",
      "link": "false",
      "alt_text": "Empty garage with automatic door opener.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/IMG_7811.jpg"
    },
    {
      "id": "ec_925bbba48525cc701f2ff5e9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc986-237c-748d-a24d-a153e3532349.webp",
      "image_media": {
        "alt_text": "Spacious wooden balcony overlooking a lush green forest under a cloudy blue sky.",
        "public_id": "019fc986-237c-748d-a24d-a153e3532349",
        "storage_key": "property/6767906449167608/019fc986-237c-748d-a24d-a153e3532349.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Enjoy your private balcony with a beautiful view of the surrounding trees. Perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Spacious wooden balcony overlooking a lush green forest under a cloudy blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/IMG_7807.jpg"
    },
    {
      "id": "ec_b7b50059ec957d7666775bf9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc986-2702-7604-93c2-dbd23143a21c.webp",
      "image_media": {
        "alt_text": "Monument sign for The Shops & Apartments of Prairie Creek.",
        "public_id": "019fc986-2702-7604-93c2-dbd23143a21c",
        "storage_key": "property/6767906449167608/019fc986-2702-7604-93c2-dbd23143a21c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to The Shops & Apartments of Prairie Creek, offering a vibrant living experience with options to shop, dine, and live.",
      "link": "false",
      "alt_text": "Monument sign for The Shops & Apartments of Prairie Creek.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Prairie-Creek-038.jpg"
    },
    {
      "id": "ec_d720242cae78b8c1e751ffb7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc986-21fa-74ee-9ecd-27b7ab206547.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at sunset.",
        "public_id": "019fc986-21fa-74ee-9ecd-27b7ab206547",
        "storage_key": "property/6767906449167608/019fc986-21fa-74ee-9ecd-27b7ab206547.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy the beautiful sunset by our resort-style swimming pool, complete with comfortable lounge chairs and umbrellas for ultimate relaxation.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at sunset.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/01-DJI_20240523150152_0563_D-VT--Edit.jpg"
    },
    {
      "id": "ec_a1eaaf19b129a1919e2b1046",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-9caa-76f9-bcff-fc410f60aa57.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with fire pit, pergola, and lounge seating.",
        "public_id": "01a0b603-9caa-76f9-bcff-fc410f60aa57",
        "storage_key": "property/6767906449167608/01a0b603-9caa-76f9-bcff-fc410f60aa57.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy the outdoors with our community's fire pit, comfortable lounge seating, and covered pergola. Perfect for relaxing or socializing.",
      "link": "false",
      "alt_text": "Outdoor seating area with fire pit, pergola, and lounge seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/13-DSC06031-Edit.jpg"
    },
    {
      "id": "ec_c89dfb637ea411e6fabfe0cf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-89c5-73b1-abdd-2a47fe4690e5.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and lounge area with seating and grills.",
        "public_id": "01a0b603-89c5-73b1-abdd-2a47fe4690e5",
        "storage_key": "property/6767906449167608/01a0b603-89c5-73b1-abdd-2a47fe4690e5.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy the resort-style swimming pool, perfect for relaxing and entertaining, with ample lounge seating and outdoor grilling stations.",
      "link": "false",
      "alt_text": "Outdoor swimming pool and lounge area with seating and grills.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/06-DJI_20240523151113_0622_D-Edit.jpg"
    },
    {
      "id": "ec_919109b83aba10865dc75773",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-a457-73c7-919a-39ad172f321b.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and lounge area with outdoor seating and umbrellas.",
        "public_id": "01a0b603-a457-73c7-919a-39ad172f321b",
        "storage_key": "property/6767906449167608/01a0b603-a457-73c7-919a-39ad172f321b.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning resort-style swimming pool, complete with a cascading waterfall and ample lounge seating. Perfect for relaxation and fun under the sun.",
      "link": "false",
      "alt_text": "Resort-style swimming pool and lounge area with outdoor seating and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/04-DJI_20240523150804_0594_D-Edit.jpg"
    },
    {
      "id": "ec_7089b611206b163d5ff23324",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-9150-767c-8dab-a5e2264cd7a9.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and clubhouse area with lounge chairs and umbrellas.",
        "public_id": "01a0b603-9150-767c-8dab-a5e2264cd7a9",
        "storage_key": "property/6767906449167608/01a0b603-9150-767c-8dab-a5e2264cd7a9.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy the beautiful outdoor swimming pool and clubhouse, perfect for relaxation and entertainment. Features ample lounge seating and shaded areas.",
      "link": "false",
      "alt_text": "Aerial view of a resort-style swimming pool and clubhouse area with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/05-DJI_20240523150901_0609_D-Edit-Edit-Edit.jpg"
    },
    {
      "id": "ec_8a84c977fd7f5bd3525d287f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-9221-74c6-8312-b1b07a79d003.webp",
      "image_media": {
        "alt_text": "Beautiful outdoor swimming pool with lounge chairs and umbrellas on a sunny day.",
        "public_id": "01a0b603-9221-74c6-8312-b1b07a79d003",
        "storage_key": "property/6767906449167608/01a0b603-9221-74c6-8312-b1b07a79d003.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, complete with comfortable lounge seating and shaded areas.",
      "link": "false",
      "alt_text": "Beautiful outdoor swimming pool with lounge chairs and umbrellas on a sunny day.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/09-DSC05841-Edit.jpg"
    },
    {
      "id": "ec_c12ae7bb62529b30e9f86bc9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-9928-7569-9222-b176025acaad.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a0b603-9928-7569-9222-b176025acaad",
        "storage_key": "property/6767906449167608/01a0b603-9928-7569-9222-b176025acaad.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and shaded umbrellas. Enjoy a refreshing dip or soak up the sun in this beautiful community amenity.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/10-DSC05896.jpg"
    },
    {
      "id": "ec_8b1ec6623a958fb6b0b46071",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-9b57-72ec-b16e-b973aaecd521.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen with bar seating, grill, and fireplace under a pergola.",
        "public_id": "01a0b603-9b57-72ec-b16e-b973aaecd521",
        "storage_key": "property/6767906449167608/01a0b603-9b57-72ec-b16e-b973aaecd521.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy outdoor entertaining with a fully equipped outdoor kitchen, complete with a grill, bar seating, and a cozy fireplace.",
      "link": "false",
      "alt_text": "Outdoor kitchen with bar seating, grill, and fireplace under a pergola.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/16-DSC06101.jpg"
    },
    {
      "id": "ec_7bebf785e21bd5f003b3cdf6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc986-31a9-75bc-9cd7-6c49439b6384.webp",
      "image_media": {
        "alt_text": "Community kitchen and dining area with a long table and island.",
        "public_id": "019fc986-31a9-75bc-9cd7-6c49439b6384",
        "storage_key": "property/6767906449167608/019fc986-31a9-75bc-9cd7-6c49439b6384.webp",
        "width": 2970,
        "height": 1980
      },
      "title": "Community",
      "description": "Gather in the stylish community kitchen and dining area, perfect for socializing or events. Features a large table and a full-service island.",
      "link": "false",
      "alt_text": "Community kitchen and dining area with a long table and island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Prairie-Creek-007.jpg"
    },
    {
      "id": "ec_ef7ef1bd9edd336457bc1a88",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc986-3378-75de-87eb-76431ed0bf4d.webp",
      "image_media": {
        "alt_text": "Fully equipped fitness center with cardio machines and free weights.",
        "public_id": "019fc986-3378-75de-87eb-76431ed0bf4d",
        "storage_key": "property/6767906449167608/019fc986-3378-75de-87eb-76431ed0bf4d.webp",
        "width": 2949,
        "height": 1966
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a wide range of cardio equipment and weight training machines to help you achieve your wellness goals.",
      "link": "false",
      "alt_text": "Fully equipped fitness center with cardio machines and free weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Prairie-Creek-011.jpg"
    },
    {
      "id": "ec_1e2a108ac9a643760fd6698e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc986-35d1-72d9-b8c4-2104ec34ce37.webp",
      "image_media": {
        "alt_text": "Well-equipped fitness center with cardio machines and weight training equipment.",
        "public_id": "019fc986-35d1-72d9-b8c4-2104ec34ce37",
        "storage_key": "property/6767906449167608/019fc986-35d1-72d9-b8c4-2104ec34ce37.webp",
        "width": 2912,
        "height": 1942
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring a variety of cardio and strength training equipment for a complete workout.",
      "link": "false",
      "alt_text": "Well-equipped fitness center with cardio machines and weight training equipment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Prairie-Creek-013.jpg"
    },
    {
      "id": "ec_8bc6814985affeb41093a386",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-a5cf-746a-8f21-ca091099e22d.webp",
      "image_media": {
        "alt_text": "Modern lounge area with a TV and yoga mats, opening to a fitness center.",
        "public_id": "01a0b603-a5cf-746a-8f21-ca091099e22d",
        "storage_key": "property/6767906449167608/01a0b603-a5cf-746a-8f21-ca091099e22d.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lounge, complete with a large screen TV. Adjacent to a fully equipped fitness center, this space offers the perfect blend of comfort and wellness.",
      "link": "false",
      "alt_text": "Modern lounge area with a TV and yoga mats, opening to a fitness center.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/08-DSC05803-Edit.jpg"
    },
    {
      "id": "ec_1c059809453a505131692c9c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-a927-7503-874b-62db710e9fd3.webp",
      "image_media": {
        "alt_text": "Spacious room with geometric patterned carpet, wall-mounted TV, and windows.",
        "public_id": "01a0b603-a927-7503-874b-62db710e9fd3",
        "storage_key": "property/6767906449167608/01a0b603-a927-7503-874b-62db710e9fd3.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "A large, empty room featuring a striking geometric carpet, a wall-mounted television, and multiple windows providing natural light.",
      "link": "false",
      "alt_text": "Spacious room with geometric patterned carpet, wall-mounted TV, and windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/07-DSC05798.jpg"
    },
    {
      "id": "ec_40c5010203d90b8cb3465196",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc986-4124-73eb-89a5-d481fcd6287e.webp",
      "image_media": {
        "alt_text": "Attached garage with carport and car vacuum.",
        "public_id": "019fc986-4124-73eb-89a5-d481fcd6287e",
        "storage_key": "property/6767906449167608/019fc986-4124-73eb-89a5-d481fcd6287e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "This property features an attached garage with a convenient carport and a car vacuum station for residents.",
      "link": "false",
      "alt_text": "Attached garage with carport and car vacuum.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Prairie-Creek-031.jpg"
    },
    {
      "id": "ec_5f80e74c5327a0fdc125fddd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc986-464a-70ad-b6ec-b12083486cfd.webp",
      "image_media": {
        "alt_text": "Outdoor basketball court with colorful surface and modern lighting.",
        "public_id": "019fc986-464a-70ad-b6ec-b12083486cfd",
        "storage_key": "property/6767906449167608/019fc986-464a-70ad-b6ec-b12083486cfd.webp",
        "width": 3013,
        "height": 2008
      },
      "title": "Community",
      "description": "Enjoy a friendly game on our vibrant outdoor basketball court, complete with modern lighting for evening play.",
      "link": "false",
      "alt_text": "Outdoor basketball court with colorful surface and modern lighting.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Prairie-Creek-035.jpg"
    },
    {
      "id": "ec_7ff2e4d15833fff204faf93b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc986-45e5-775d-b83f-a7fcec1796f9.webp",
      "image_media": {
        "alt_text": "Standing tanning bed in a room with a painting and a chair.",
        "public_id": "019fc986-45e5-775d-b83f-a7fcec1796f9",
        "storage_key": "property/6767906449167608/019fc986-45e5-775d-b83f-a7fcec1796f9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax in our state-of-the-art tanning bed, perfect for achieving a golden glow. This amenity is available for resident use.",
      "link": "false",
      "alt_text": "Standing tanning bed in a room with a painting and a chair.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Prairie-Creek-016.jpg"
    },
    {
      "id": "ec_4b3c26c1a8aa7cce3915a589",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc986-45d7-750b-95f2-9b7a5311cbe5.webp",
      "image_media": {
        "alt_text": "Business center with computers, printer, and chairs.",
        "public_id": "019fc986-45d7-750b-95f2-9b7a5311cbe5",
        "storage_key": "property/6767906449167608/019fc986-45d7-750b-95f2-9b7a5311cbe5.webp",
        "width": 3024,
        "height": 2016
      },
      "title": "Community",
      "description": "Stay connected in our convenient business center, featuring computers and a printer for all your needs.",
      "link": "false",
      "alt_text": "Business center with computers, printer, and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Prairie-Creek-006.jpg"
    },
    {
      "id": "ec_bdbd5b34cc0c4705a85f4a93",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-cb79-771f-9020-34852f16cf96.webp",
      "image_media": {
        "alt_text": "Community lounge with pool table, seating area, and TV.",
        "public_id": "01a0b603-cb79-771f-9020-34852f16cf96",
        "storage_key": "property/6767906449167608/01a0b603-cb79-771f-9020-34852f16cf96.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy leisure time in the community lounge, complete with a billiards table, comfortable seating, and entertainment options.",
      "link": "false",
      "alt_text": "Community lounge with pool table, seating area, and TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/17-DSC06178.jpg"
    },
    {
      "id": "ec_5eddc21a05f1f90761ae1c7e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-cb5d-748a-aa7d-01b96e353eac.webp",
      "image_media": {
        "alt_text": "Modern lounge area with sectional sofa, coffee tables, and a TV.",
        "public_id": "01a0b603-cb5d-748a-aa7d-01b96e353eac",
        "storage_key": "property/6767906449167608/01a0b603-cb5d-748a-aa7d-01b96e353eac.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Relax in our stylish community lounge, perfect for socializing or unwinding.",
      "link": "false",
      "alt_text": "Modern lounge area with sectional sofa, coffee tables, and a TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/18-DSC06188-Edit.jpg"
    },
    {
      "id": "ec_f2a0bd490ddeda0f378742e6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b603-b7da-71dc-9ced-607f87d76a1d.webp",
      "image_media": {
        "alt_text": "Modern apartment building lobby with a reception desk, seating area, and coffee station.",
        "public_id": "01a0b603-b7da-71dc-9ced-607f87d76a1d",
        "storage_key": "property/6767906449167608/01a0b603-b7da-71dc-9ced-607f87d76a1d.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Welcome to our apartment community's stylish lobby, featuring a contemporary reception area, comfortable seating, and a convenient coffee station for residents.",
      "link": "false",
      "alt_text": "Modern apartment building lobby with a reception desk, seating area, and coffee station.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/19-DSC06192-Edit copy.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_56427b6d-fdc3-4a9e-804b-d27e655a636d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Enjoy Pure Food + Drink",
      "poi_type": "Restaurants",
      "poi_address": "8729 Scarborough St, Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019ff6ad-bdaf-738a-a68b-38c1ce895c2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-bdaf-738a-a68b-38c1ce895c2f",
        "storage_key": "property/6767906449167608/019ff6ad-bdaf-738a-a68b-38c1ce895c2f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://enjoypurefood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12858218293445758583&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "enjoy-pure-food--drink",
      "poi_latitude": "38.9696882",
      "poi_longitude": "-94.781239",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-248-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fce6-7730-b10a-74fed820d2e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fce6-7730-b10a-74fed820d2e7",
        "storage_key": "property/6767906449167608/019fc984-fce6-7730-b10a-74fed820d2e7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpf3LMpSVwIcRd45DgWmRcbI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_a156c8fe-58d0-489c-971f-3657aa335102",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Cactus Grill",
      "poi_type": "Restaurants",
      "poi_address": "8721 Scarborough St, Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019ff6ad-b77c-730c-82d0-a97085128e64.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-b77c-730c-82d0-a97085128e64",
        "storage_key": "property/6767906449167608/019ff6ad-b77c-730c-82d0-a97085128e64.webp",
        "width": 1280,
        "height": 903
      },
      "poi_business_url": "https://www.cactusgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12116620822785664290&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cactus-grill",
      "poi_latitude": "38.96997",
      "poi_longitude": "-94.781347",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-413-8192",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fce6-7730-b10a-74fed820d2e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fce6-7730-b10a-74fed820d2e7",
        "storage_key": "property/6767906449167608/019fc984-fce6-7730-b10a-74fed820d2e7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW65GZgCVwIcRIqU9FHHiJqg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tex_mex_restaurant"
    },
    {
      "id": "custom_5418511a-5ef3-4597-8fd3-f3854a376827",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Cardboard Corner Cafe at Lenexa Public Market",
      "poi_type": "Restaurants",
      "poi_address": "8750 Penrose Ln, Lenexa, KS 66219, USA",
      "poi_short_description": "Board-game store featuring a cafe menu offering waffles and boba teas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a01012-f315-706c-b141-1544223aa79c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01012-f315-706c-b141-1544223aa79c",
        "storage_key": "property/6767906449167608/01a01012-f315-706c-b141-1544223aa79c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://cardboardcornerkc.com/lpm",
      "poi_directions_map_url": "https://maps.google.com/?cid=3621796632906871678&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cardboard-corner-cafe-at-lenexa-public-market",
      "poi_latitude": "38.9698804",
      "poi_longitude": "-94.7842487",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-265-4080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fce6-7730-b10a-74fed820d2e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fce6-7730-b10a-74fed820d2e7",
        "storage_key": "property/6767906449167608/019fc984-fce6-7730-b10a-74fed820d2e7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwRVQTtqVwIcRfrMeOdk0QzI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_9d7fb723-0b5a-459f-9d5c-b7192e6fcb36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Lenexa Public Market",
      "poi_type": "Restaurants",
      "poi_address": "8750 Penrose Ln, Lenexa, KS 66219, USA",
      "poi_short_description": "Hip venue with trendy eateries & communal seating, plus small local merchants for clothing & more.",
      "poi_long_description": "Hip venue with trendy eateries & communal seating, plus small local merchants for clothing & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc987-3242-7032-b852-ed02fe49cc6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-3242-7032-b852-ed02fe49cc6c",
        "storage_key": "property/6767906449167608/019fc987-3242-7032-b852-ed02fe49cc6c.webp",
        "width": 1280,
        "height": 767
      },
      "poi_business_url": "http://www.lenexapublicmarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10083005860736764828&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lenexa-public-market",
      "poi_latitude": "38.9699268",
      "poi_longitude": "-94.7837294",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-477-7516",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fce6-7730-b10a-74fed820d2e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fce6-7730-b10a-74fed820d2e7",
        "storage_key": "property/6767906449167608/019fc984-fce6-7730-b10a-74fed820d2e7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIbehyHaUwIcRnItlhWgI7os",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "food_court"
    },
    {
      "id": "custom_19d9cc92-b75b-4a89-a69f-9a71ffe8ac43",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Grand Street Lenexa",
      "poi_type": "Restaurants",
      "poi_address": "8815 Renner Blvd, Lenexa, KS 66219, USA",
      "poi_short_description": "Dining destination offering elevated American fare & a lengthy wine list in a contemporary setting.",
      "poi_long_description": "Dining destination offering elevated American fare & a lengthy wine list in a contemporary setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a01012-eec7-74a9-9174-382312064030.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01012-eec7-74a9-9174-382312064030",
        "storage_key": "property/6767906449167608/01a01012-eec7-74a9-9174-382312064030.webp",
        "width": 1280,
        "height": 657
      },
      "poi_business_url": "http://grandstreetlenexa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4288467701067941316&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grand-street-lenexa",
      "poi_latitude": "38.9685061",
      "poi_longitude": "-94.7788194",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-601-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fce6-7730-b10a-74fed820d2e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fce6-7730-b10a-74fed820d2e7",
        "storage_key": "property/6767906449167608/019fc984-fce6-7730-b10a-74fed820d2e7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLU7XoHCUwIcRxAXkIKeygzs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_d914b8d0-7650-4347-afa2-ec3a96b02dec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Martin City Brewing Co. Pizza & Taproom - Lenexa",
      "poi_type": "Restaurants",
      "poi_address": "8802 Renner Blvd, Lenexa, KS 66219, USA",
      "poi_short_description": "Casual family-friendly beer specialist with a pizzeria, serving a menu of beers on tap, cocktails, burgers, salads and pretzels.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc987-2c4b-74e8-8c19-16a3c848ed18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-2c4b-74e8-8c19-16a3c848ed18",
        "storage_key": "property/6767906449167608/019fc987-2c4b-74e8-8c19-16a3c848ed18.webp",
        "width": 1280,
        "height": 625
      },
      "poi_business_url": "http://martincitybrewingcompany.com/locations",
      "poi_directions_map_url": "https://maps.google.com/?cid=15064962677990831093&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "martin-city-brewing-co-pizza--taproom---lenexa",
      "poi_latitude": "38.9687965",
      "poi_longitude": "-94.7801528",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-434-6086",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fce6-7730-b10a-74fed820d2e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fce6-7730-b10a-74fed820d2e7",
        "storage_key": "property/6767906449167608/019fc984-fce6-7730-b10a-74fed820d2e7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYSNNnp2VwIcR9TMp8Lx_EdE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_3ae7f794-f225-448b-9088-8c5744328a26",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Sierra Grill",
      "poi_type": "Restaurants",
      "poi_address": "8659 Penrose Ln, Lenexa, KS 66219, USA",
      "poi_short_description": "Laid-back steakhouse offering grilled steak, chicken & seafood, plus wine & specialty cocktails.",
      "poi_long_description": "Laid-back steakhouse offering grilled steak, chicken & seafood, plus wine & specialty cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc987-2b38-74df-9372-53a4445c1e38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-2b38-74df-9372-53a4445c1e38",
        "storage_key": "property/6767906449167608/019fc987-2b38-74df-9372-53a4445c1e38.webp",
        "width": 1280,
        "height": 1212
      },
      "poi_business_url": "http://sierragrillkc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9376761955747932456&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sierra-grill",
      "poi_latitude": "38.9719805",
      "poi_longitude": "-94.7835995",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-599-3555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fce6-7730-b10a-74fed820d2e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fce6-7730-b10a-74fed820d2e7",
        "storage_key": "property/6767906449167608/019fc984-fce6-7730-b10a-74fed820d2e7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJm5ykZgOVwIcRKKnAi1HzIII",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_2f39ce69-8bb3-483b-b884-2f551c2ea692",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Tupelo Honey Southern Kitchen & Bar",
      "poi_type": "Restaurants",
      "poi_address": "16720 City Center Dr, Lenexa, KS 66219, USA",
      "poi_short_description": "An all-day menu of Southern comfort food with a creative twist, plus craft beers & cocktails.",
      "poi_long_description": "An all-day menu of Southern comfort food with a creative twist, plus craft beers & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a01012-f250-70e9-a88c-6466d36f5b28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01012-f250-70e9-a88c-6466d36f5b28",
        "storage_key": "property/6767906449167608/01a01012-f250-70e9-a88c-6466d36f5b28.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://tupelohoneycafe.com/?olonwp=JjBtp_vMLk25gkYh_bnoiQ",
      "poi_directions_map_url": "https://maps.google.com/?cid=7467157571181511213&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tupelo-honey-southern-kitchen--bar",
      "poi_latitude": "38.96928740000001",
      "poi_longitude": "-94.7801009",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-220-2013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fce6-7730-b10a-74fed820d2e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fce6-7730-b10a-74fed820d2e7",
        "storage_key": "property/6767906449167608/019fc984-fce6-7730-b10a-74fed820d2e7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZcYJDQCVwIcRLYIkkD-soGc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_6f49cc9c-c6d5-41f3-9b80-cc6e886fab1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Zhoug Mediterranean",
      "poi_type": "Restaurants",
      "poi_address": "16728 City Center Dr, Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a01012-ef32-775d-a72c-3bc3fc7e8755.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01012-ef32-775d-a72c-3bc3fc7e8755",
        "storage_key": "property/6767906449167608/01a01012-ef32-775d-a72c-3bc3fc7e8755.webp",
        "width": 1280,
        "height": 963
      },
      "poi_business_url": "https://www.zhoug.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8336412163353775432&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "zhoug-mediterranean",
      "poi_latitude": "38.96921469999999",
      "poi_longitude": "-94.7805131",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-242-7123",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fce6-7730-b10a-74fed820d2e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fce6-7730-b10a-74fed820d2e7",
        "storage_key": "property/6767906449167608/019fc984-fce6-7730-b10a-74fed820d2e7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBUw3oUqVwIcRSI3ywbHisHM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_619018ed-d25f-4c1a-9eee-562eee9f52b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Saints Pub + Patio Lenexa City Center",
      "poi_type": "Restaurants",
      "poi_address": "16804 W 89th St, Lenexa, KS 66219, USA",
      "poi_short_description": "Large, casual bar & grill offering hearty, made-from-scratch American eats & sports-viewing.",
      "poi_long_description": "Large, casual bar & grill offering hearty, made-from-scratch American eats & sports-viewing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a01012-edbc-7051-a868-1984c8e37a42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01012-edbc-7051-a868-1984c8e37a42",
        "storage_key": "property/6767906449167608/01a01012-edbc-7051-a868-1984c8e37a42.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://saintspub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2100928090597587192&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saints-pub--patio-lenexa-city-center",
      "poi_latitude": "38.967624",
      "poi_longitude": "-94.7802676",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-827-3583",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019ff6ae-06dd-74c6-a87b-9b4d632ea648.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6ae-06dd-74c6-a87b-9b4d632ea648",
        "storage_key": "property/6767906449167608/019ff6ae-06dd-74c6-a87b-9b4d632ea648.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjd5tsHCUwIcR-Hi1mvf-Jx0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_bar"
    },
    {
      "id": "custom_8950c0bb-baa5-4246-9ab5-65af874ea872",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Silo Modern Farmhouse",
      "poi_type": "Restaurants",
      "poi_address": "17501 W 87th St, Lenexa, KS 66219, USA",
      "poi_short_description": "American & internationally inspired dishes in a contemporary setting overlooking a golf course.",
      "poi_long_description": "American & internationally inspired dishes in a contemporary setting overlooking a golf course.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a01012-ed48-7079-ab4d-7866fab94d8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01012-ed48-7079-ab4d-7866fab94d8c",
        "storage_key": "property/6767906449167608/01a01012-ed48-7079-ab4d-7866fab94d8c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.silocanyonfarms.com/?utm_source=Google&utm_medium=BusinessListing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4920430405167520750&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "silo-modern-farmhouse",
      "poi_latitude": "38.9691436",
      "poi_longitude": "-94.7910646",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-278-0910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fce6-7730-b10a-74fed820d2e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fce6-7730-b10a-74fed820d2e7",
        "storage_key": "property/6767906449167608/019fc984-fce6-7730-b10a-74fed820d2e7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGVBXrMWVwIcR7psKSmLhSEQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_7617ceff-9a96-4779-b77c-94239f92c29c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Sushi UNI",
      "poi_type": "Restaurants",
      "poi_address": "12841 W 87th St Pkwy, Lenexa, KS 66215, USA",
      "poi_short_description": "Compact, busy strip-mall venue for traditional Japanese sushi, sashimi, salads & hot entrees.",
      "poi_long_description": "Compact, busy strip-mall venue for traditional Japanese sushi, sashimi, salads & hot entrees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019ff6ad-bb72-77ab-90b0-3f37e0d4ff5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-bb72-77ab-90b0-3f37e0d4ff5c",
        "storage_key": "property/6767906449167608/019ff6ad-bb72-77ab-90b0-3f37e0d4ff5c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ordersushiuni.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2788749059343652231&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sushi-uni",
      "poi_latitude": "38.9703578",
      "poi_longitude": "-94.7351629",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-322-8667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fce6-7730-b10a-74fed820d2e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fce6-7730-b10a-74fed820d2e7",
        "storage_key": "property/6767906449167608/019fc984-fce6-7730-b10a-74fed820d2e7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWQVgBqmUwIcRhxXieX6gsyY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_d0643cd9-ff3a-42f3-a1e6-a1a2e9939052",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Ronnie's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "12812 W 87th St, Lenexa, KS 66215, USA",
      "poi_short_description": "Hearty breakfasts & sandwiches are menu staples at this locally owned joint with a relaxed ambiance.",
      "poi_long_description": "Hearty breakfasts & sandwiches are menu staples at this locally owned joint with a relaxed ambiance.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019ff6d8-1fd9-712b-a2dc-3cbafdc9f3f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6d8-1fd9-712b-a2dc-3cbafdc9f3f8",
        "storage_key": "property/6767906449167608/019ff6d8-1fd9-712b-a2dc-3cbafdc9f3f8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://kateskitchenkc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2637527507810122868&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ronnies-restaurant",
      "poi_latitude": "38.9718209",
      "poi_longitude": "-94.7345842",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-831-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fce6-7730-b10a-74fed820d2e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fce6-7730-b10a-74fed820d2e7",
        "storage_key": "property/6767906449167608/019fc984-fce6-7730-b10a-74fed820d2e7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPSltPKmUwIcRdPxXTEthmiQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brunch_restaurant"
    },
    {
      "id": "custom_668ed81d-d252-4a64-a05a-f4adca008a4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Chartroose Caboose",
      "poi_type": "Restaurants",
      "poi_address": "12976 W 87th St Pkwy, Lenexa, KS 66215, USA",
      "poi_short_description": "Casual restaurant known for Philly cheesesteaks and burgers plus hoagies, and ice cream.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019ff6d8-22e7-754d-a21f-b3e286e69bea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6d8-22e7-754d-a21f-b3e286e69bea",
        "storage_key": "property/6767906449167608/019ff6d8-22e7-754d-a21f-b3e286e69bea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://chartroosecaboosekc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5938671651070160249&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chartroose-caboose",
      "poi_latitude": "38.9714934",
      "poi_longitude": "-94.7363342",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-660-0180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fce6-7730-b10a-74fed820d2e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fce6-7730-b10a-74fed820d2e7",
        "storage_key": "property/6767906449167608/019fc984-fce6-7730-b10a-74fed820d2e7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ370TwaiUwIcReS2492ZmalI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_43c640a9-a862-4f55-91f2-d77c07740a0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "McKeever's Market & Eatery",
      "poi_type": "Shopping & Retail",
      "poi_address": "8800 Maurer Ct, Lenexa, KS 66219, USA",
      "poi_short_description": "Upscale chain of stores supplying ready-made meals, seafood and beers, plus freshly baked cakes and breads.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019ff6ad-cc39-7139-86fc-8f313c62e8de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-cc39-7139-86fc-8f313c62e8de",
        "storage_key": "property/6767906449167608/019ff6ad-cc39-7139-86fc-8f313c62e8de.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mckeeversmarketandeatery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8714415342264487958&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mckeevers-market--eatery",
      "poi_latitude": "38.968711",
      "poi_longitude": "-94.7741037",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-766-1012",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fce8-75cc-8ad1-17cd98e860af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fce8-75cc-8ad1-17cd98e860af",
        "storage_key": "property/6767906449167608/019fc984-fce8-75cc-8ad1-17cd98e860af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNQtro4aVwIcRFpDjNJXS73g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_38eaab30-e118-4f56-9453-6c2a5db3d19a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "8550 Maurer Rd, Lenexa, KS 66219, USA",
      "poi_short_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_long_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019ff6ad-c346-738b-aaa9-91d744d096ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-c346-738b-aaa9-91d744d096ca",
        "storage_key": "property/6767906449167608/019ff6ad-c346-738b-aaa9-91d744d096ca.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://sprouts.com/store/ks/lenexa/lenexa",
      "poi_directions_map_url": "https://maps.google.com/?cid=18116198236188620164&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "38.972975",
      "poi_longitude": "-94.772813",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-312-1586",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fce8-75cc-8ad1-17cd98e860af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fce8-75cc-8ad1-17cd98e860af",
        "storage_key": "property/6767906449167608/019fc984-fce8-75cc-8ad1-17cd98e860af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi7IxC3-UwIcRhLWU5E-qafs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_c8c5ca4f-86e7-40bc-a15a-e3e74d42ea40",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Hen House Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "15000 W 87th St Pkwy, Lenexa, KS 66215, USA",
      "poi_short_description": "Grocery store featuring a salad bar along with house-made and organic goods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a01012-f698-72b3-9663-72606a927b5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01012-f698-72b3-9663-72606a927b5b",
        "storage_key": "property/6767906449167608/01a01012-f698-72b3-9663-72606a927b5b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://henhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14200189744630429157&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hen-house-market",
      "poi_latitude": "38.9724477",
      "poi_longitude": "-94.7597369",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-599-6423",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fce8-75cc-8ad1-17cd98e860af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fce8-75cc-8ad1-17cd98e860af",
        "storage_key": "property/6767906449167608/019fc984-fce8-75cc-8ad1-17cd98e860af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJae5kJYOUwIcR5XXXP1Y1EcU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_a14d65da-c029-47d3-8fb2-0dabc021507a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Hy-Vee Grocery Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "13400 W 87th St Pkwy, Lenexa, KS 66215, USA",
      "poi_short_description": "Neighborhood grocery store chain with a bakery, pharmacy and deli section.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc987-3cbc-7288-b5cf-4e544d23a76c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-3cbc-7288-b5cf-4e544d23a76c",
        "storage_key": "property/6767906449167608/019fc987-3cbc-7288-b5cf-4e544d23a76c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hy-vee.com/stores/detail.aspx?s=88&utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=3848803178573539019&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hy-vee-grocery-store",
      "poi_latitude": "38.9722951",
      "poi_longitude": "-94.7411834",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-438-8308",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fce8-75cc-8ad1-17cd98e860af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fce8-75cc-8ad1-17cd98e860af",
        "storage_key": "property/6767906449167608/019fc984-fce8-75cc-8ad1-17cd98e860af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI4nU7KaUwIcRyyZFXRmyaTU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_06e11940-5d96-4409-a03b-be97b89576e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "15751 W 87th St, Lenexa, KS 66219, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc987-3d19-7653-9c23-b97f88ae79fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-3d19-7653-9c23-b97f88ae79fe",
        "storage_key": "property/6767906449167608/019fc987-3d19-7653-9c23-b97f88ae79fe.webp",
        "width": 1280,
        "height": 653
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ks/lenexa/15751-w-87th-street-parkway/f304",
      "poi_directions_map_url": "https://maps.google.com/?cid=9937914090544876237&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "38.96989200000001",
      "poi_longitude": "-94.768913",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fce8-75cc-8ad1-17cd98e860af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fce8-75cc-8ad1-17cd98e860af",
        "storage_key": "property/6767906449167608/019fc984-fce8-75cc-8ad1-17cd98e860af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwQwvoYCUwIcRzcpGRzaQ6ok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_a5c97c85-f769-4ef6-89e2-d22559b94b2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "15100 W 87th St Pkwy, Lenexa, KS 66219, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc987-3d35-77fb-be8f-9977d52503a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-3d35-77fb-be8f-9977d52503a4",
        "storage_key": "property/6767906449167608/019fc987-3d35-77fb-be8f-9977d52503a4.webp",
        "width": 1280,
        "height": 655
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-15100+w+87th+street+pkwy-lenexa-ks-66219/id=4186",
      "poi_directions_map_url": "https://maps.google.com/?cid=15113763039521280157&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "38.9717131",
      "poi_longitude": "-94.7617069",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-438-5172",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcbc-744b-be91-9b2ee9935387.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcbc-744b-be91-9b2ee9935387",
        "storage_key": "property/6767906449167608/019fc984-fcbc-744b-be91-9b2ee9935387.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc4Y-VIKUwIcRnRAYhmjfvtE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_6f45dfe0-92c6-4186-b726-96753e759c50",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "12200 W 95th St, Lenexa, KS 66215, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc987-3ec0-77a8-af69-6e6736e23b2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-3ec0-77a8-af69-6e6736e23b2f",
        "storage_key": "property/6767906449167608/019fc987-3ec0-77a8-af69-6e6736e23b2f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.samsclub.com/club/8208-lenexa-ks",
      "poi_directions_map_url": "https://maps.google.com/?cid=7684576317405793027&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sams-club",
      "poi_latitude": "38.9592633",
      "poi_longitude": "-94.72728990000002",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-894-0084",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fccb-73cd-bdc9-5da275746b7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fccb-73cd-bdc9-5da275746b7f",
        "storage_key": "property/6767906449167608/019fc984-fccb-73cd-bdc9-5da275746b7f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-RimSUvrwIcRAwtaMHIZpWo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_762a573d-beda-4586-816f-7feb95e38949",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "9350 Marshall Dr, Lenexa, KS 66215, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc987-4037-74eb-99cb-c2b7e45719f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-4037-74eb-99cb-c2b7e45719f6",
        "storage_key": "property/6767906449167608/019fc987-4037-74eb-99cb-c2b7e45719f6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/lenexa-KS-349.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=1564556256895062367&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "38.958711",
      "poi_longitude": "-94.733897",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-227-3703",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fccb-73cd-bdc9-5da275746b7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fccb-73cd-bdc9-5da275746b7f",
        "storage_key": "property/6767906449167608/019fc984-fccb-73cd-bdc9-5da275746b7f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJ59sp7aUwIcRX1FYU6BrthU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_8f516226-9524-4d0c-933d-1efe514cfa9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Southwind Cycle and Outdoor Lenexa",
      "poi_type": "Shopping & Retail",
      "poi_address": "13624 W 87th St Pkwy, Lenexa, KS 66215, USA",
      "poi_short_description": "Locally owned and operated bike shop specializing in mountain bikes, gravel bikes, and road bikes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a01012-f75b-7358-9829-61d1485af901.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01012-f75b-7358-9829-61d1485af901",
        "storage_key": "property/6767906449167608/01a01012-f75b-7358-9829-61d1485af901.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://southwindcycle.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8943501347215723007&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southwind-cycle-and-outdoor-lenexa",
      "poi_latitude": "38.9719379",
      "poi_longitude": "-94.7441908",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-888-0533",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fccb-73cd-bdc9-5da275746b7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fccb-73cd-bdc9-5da275746b7f",
        "storage_key": "property/6767906449167608/019fc984-fccb-73cd-bdc9-5da275746b7f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJBUTmx7uUwIcR_0kFMRezHXw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bicycle_store"
    },
    {
      "id": "custom_4ae54845-5fdf-4c4e-a312-21d8933ebdb1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Lenexa Hills Elementary",
      "poi_type": "Education",
      "poi_address": "8650 Haven St, Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc987-42ae-750c-bc90-d90c09a56246.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-42ae-750c-bc90-d90c09a56246",
        "storage_key": "property/6767906449167608/019fc987-42ae-750c-bc90-d90c09a56246.webp",
        "width": 1280,
        "height": 632
      },
      "poi_business_url": "https://lenexahills.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9767865042949672121&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lenexa-hills-elementary",
      "poi_latitude": "38.9719677",
      "poi_longitude": "-94.7945169",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-993-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcbd-7378-a1a9-579b1c785c50.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcbd-7378-a1a9-579b1c785c50",
        "storage_key": "property/6767906449167608/019fc984-fcbd-7378-a1a9-579b1c785c50.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMU-AKpSTwIcRuYz4EoFtjoc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_65385a45-8af1-4355-b8df-933ee1f40b97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Sunflower Elementary School",
      "poi_type": "Education",
      "poi_address": "8955 Loiret Blvd, Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc987-4439-725a-b3fb-7b99bc863467.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-4439-725a-b3fb-7b99bc863467",
        "storage_key": "property/6767906449167608/019fc987-4439-725a-b3fb-7b99bc863467.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://sunflower.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7638137545668298095&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunflower-elementary-school",
      "poi_latitude": "38.9653822",
      "poi_longitude": "-94.7672302",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-993-5400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcbd-7378-a1a9-579b1c785c50.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcbd-7378-a1a9-579b1c785c50",
        "storage_key": "property/6767906449167608/019fc984-fcbd-7378-a1a9-579b1c785c50.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQUmvuYeUwIcRbwUiE6EdAGo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_e2fcb187-e8d6-40c4-b671-5af8adc74803",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Christa McAuliffe Elementary",
      "poi_type": "Education",
      "poi_address": "15600 W 83rd St, Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://mcauliffe.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12171156058238824688&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "christa-mcauliffe-elementary",
      "poi_latitude": "38.9790008",
      "poi_longitude": "-94.7670552",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-993-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcbd-7378-a1a9-579b1c785c50.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcbd-7378-a1a9-579b1c785c50",
        "storage_key": "property/6767906449167608/019fc984-fcbd-7378-a1a9-579b1c785c50.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWQej1HiTwIcR8DArDfOh6Kg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_7e48d713-9344-4684-b4a0-23f8af801554",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Rosehill Elementary School",
      "poi_type": "Education",
      "poi_address": "9801 Rosehill Rd, Lenexa, KS 66215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://rosehill.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11554316795495235630&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rosehill-elementary-school",
      "poi_latitude": "38.9504768",
      "poi_longitude": "-94.7313998",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-993-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcbd-7378-a1a9-579b1c785c50.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcbd-7378-a1a9-579b1c785c50",
        "storage_key": "property/6767906449167608/019fc984-fcbd-7378-a1a9-579b1c785c50.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN0647MuUwIcRLsDSeegtWaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_128b6a75-7bf5-4bb7-8f94-5dc22f1eaeae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Westridge Middle School",
      "poi_type": "Education",
      "poi_address": "9300 Nieman Rd, Overland Park, KS 66214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019ff6ad-d345-767a-a8a5-1df1bdb01f64.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-d345-767a-a8a5-1df1bdb01f64",
        "storage_key": "property/6767906449167608/019ff6ad-d345-767a-a8a5-1df1bdb01f64.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "https://westridge.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=217242892534723488&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westridge-middle-school",
      "poi_latitude": "38.9590348",
      "poi_longitude": "-94.7157697",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-993-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcbd-7378-a1a9-579b1c785c50.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcbd-7378-a1a9-579b1c785c50",
        "storage_key": "property/6767906449167608/019fc984-fcbd-7378-a1a9-579b1c785c50.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJk5xqEUbrwIcRoLOCf0LNAwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_53dee245-ae3c-45ef-b866-529f08da87a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Shawnee Mission West High School",
      "poi_type": "Education",
      "poi_address": "8800 W 85th St, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc987-43f8-7536-b1e2-404770107918.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-43f8-7536-b1e2-404770107918",
        "storage_key": "property/6767906449167608/019fc987-43f8-7536-b1e2-404770107918.webp",
        "width": 1280,
        "height": 662
      },
      "poi_business_url": "http://smwest.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1174450894079124931&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shawnee-mission-west-high-school",
      "poi_latitude": "38.9764917",
      "poi_longitude": "-94.688317",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-993-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcbd-7378-a1a9-579b1c785c50.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcbd-7378-a1a9-579b1c785c50",
        "storage_key": "property/6767906449167608/019fc984-fcbd-7378-a1a9-579b1c785c50.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG5Gk03_rwIcRw-W5m918TBA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_a0634a54-2eb8-460c-bf96-cb4893f7ada7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Building Blocks Preschool",
      "poi_type": "Education",
      "poi_address": "15215 College Blvd, Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019ff6ad-d337-7166-be81-c32b5ba48007.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-d337-7166-be81-c32b5ba48007",
        "storage_key": "property/6767906449167608/019ff6ad-d337-7166-be81-c32b5ba48007.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.buildingblocksprek.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10940970884558186455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "building-blocks-preschool",
      "poi_latitude": "38.925917",
      "poi_longitude": "-94.7621489",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-888-7244",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcbd-7378-a1a9-579b1c785c50.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcbd-7378-a1a9-579b1c785c50",
        "storage_key": "property/6767906449167608/019fc984-fcbd-7378-a1a9-579b1c785c50.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZzz2hyaVwIcR12f7Pw0j1pc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_7687c264-95ae-4088-a9fc-b6e176e566ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Country Kids Day Care of Lenexa",
      "poi_type": "Education",
      "poi_address": "8745 Bourgade St, Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc987-4933-7209-9feb-294539580b4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-4933-7209-9feb-294539580b4c",
        "storage_key": "property/6767906449167608/019fc987-4933-7209-9feb-294539580b4c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.countrykidsdaycare.com/?utm_source=google&utm_medium=local&utm_campaign=gmb_profile_lenexa",
      "poi_directions_map_url": "https://maps.google.com/?cid=11325056340475163442&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "country-kids-day-care-of-lenexa",
      "poi_latitude": "38.96948130000001",
      "poi_longitude": "-94.7671097",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-888-9400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcbd-7378-a1a9-579b1c785c50.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcbd-7378-a1a9-579b1c785c50",
        "storage_key": "property/6767906449167608/019fc984-fcbd-7378-a1a9-579b1c785c50.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_9Bh0ICUwIcRMrNOK72uKp0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_cefc54cf-9b35-4da2-aeeb-d5fb2020e45f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Johnson County Community College",
      "poi_type": "Education",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-d2c6-741a-bc28-1847a634634e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc984-d2c6-741a-bc28-1847a634634e",
        "storage_key": "property/6767906449167608/019fc984-d2c6-741a-bc28-1847a634634e.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.jccc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4939079639992649295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-community-college",
      "poi_latitude": "38.9237619",
      "poi_longitude": "-94.7303185",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-469-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcbd-7378-a1a9-579b1c785c50.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcbd-7378-a1a9-579b1c785c50",
        "storage_key": "property/6767906449167608/019fc984-fcbd-7378-a1a9-579b1c785c50.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEejhg2TrwIcRT0Ygo8Mii0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_58c0b97c-a202-47ed-b1e9-4a9688fff618",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Holy Trinity School",
      "poi_type": "Education",
      "poi_address": "13600 W 92nd St, Lenexa, KS 66215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://htslenexa.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17794912957199867156&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "holy-trinity-school",
      "poi_latitude": "38.9619121",
      "poi_longitude": "-94.7432887",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-888-3250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcbd-7378-a1a9-579b1c785c50.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcbd-7378-a1a9-579b1c785c50",
        "storage_key": "property/6767906449167608/019fc984-fcbd-7378-a1a9-579b1c785c50.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJESE0YLyUwIcRFN3klg079PY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_b4f61a15-dcf8-4b67-92b3-25bf5784d3d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "AMC Town Center 20",
      "poi_type": "Entertainment",
      "poi_address": "11701 Nall Ave, Leawood, KS 66211, USA",
      "poi_short_description": "Modern cinema equipped with comfy seats, luxury recliners, and a snack bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019ff6d8-327c-752a-9552-afce702ac91a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6d8-327c-752a-9552-afce702ac91a",
        "storage_key": "property/6767906449167608/019ff6d8-327c-752a-9552-afce702ac91a.webp",
        "width": 1280,
        "height": 783
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/kansas-city/amc-town-center-20?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=2804340900304979407&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-town-center-20",
      "poi_latitude": "38.915838",
      "poi_longitude": "-94.648325",
      "poi_miles_from_property": "9.9",
      "poi_walking_minutes": "3 hours 40 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-498-8696",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc988-0779-732e-ba2b-d386bcdacd46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc988-0779-732e-ba2b-d386bcdacd46",
        "storage_key": "property/6767906449167608/019fc988-0779-732e-ba2b-d386bcdacd46.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6xgReh_qwIcRzwXH1zAF6yY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_e4eacaaa-8537-45ad-8e49-e8586ac7572a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "AMC Prairiefire 17",
      "poi_type": "Entertainment",
      "poi_address": "5724 W 136th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Comfortable entertainment venue featuring a full menu alongside movie screenings of new releases.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc987-4602-7144-8608-3c4f15a73a91.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-4602-7144-8608-3c4f15a73a91",
        "storage_key": "property/6767906449167608/019fc987-4602-7144-8608-3c4f15a73a91.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/kansas-city/amc-prairiefire-17?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3727223515720771879&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-prairiefire-17",
      "poi_latitude": "38.8826984",
      "poi_longitude": "-94.651566",
      "poi_miles_from_property": "11.5",
      "poi_walking_minutes": "4 hours 16 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-553-3075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc988-0779-732e-ba2b-d386bcdacd46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc988-0779-732e-ba2b-d386bcdacd46",
        "storage_key": "property/6767906449167608/019fc988-0779-732e-ba2b-d386bcdacd46.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7fXu5_DBwIcRJ-kENQrCuTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_6c95b590-fbd8-4342-b20d-2394c113a7f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "B&B Theatres Overland Park 16",
      "poi_type": "Entertainment",
      "poi_address": "8601 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Relaxed, contemporary multiscreen theater featuring showings of mainstream films.",
      "poi_long_description": "Relaxed, contemporary multiscreen theater featuring showings of mainstream films.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019ff6d8-3274-75f9-942b-9c218a6eb344.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6d8-3274-75f9-942b-9c218a6eb344",
        "storage_key": "property/6767906449167608/019ff6d8-3274-75f9-942b-9c218a6eb344.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "https://www.bbtheatres.com/our-theatres/x0uvh-b-and-b-overland-park-16/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6259761698616561138&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bb-theatres-overland-park-16",
      "poi_latitude": "38.8812512",
      "poi_longitude": "-94.6835183",
      "poi_miles_from_property": "9.8",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-871-5352",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc988-0779-732e-ba2b-d386bcdacd46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc988-0779-732e-ba2b-d386bcdacd46",
        "storage_key": "property/6767906449167608/019fc988-0779-732e-ba2b-d386bcdacd46.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJDWO_qc3BwIcR8s2iaBkk31Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_ca2be2ab-8f53-423a-bd44-482a20401093",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Museum at Prairiefire",
      "poi_type": "Entertainment",
      "poi_address": "5801 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Bright, uniquely designed museum with changing natural history exhibits on dinosaurs & space.",
      "poi_long_description": "Bright, uniquely designed museum with changing natural history exhibits on dinosaurs & space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc987-4802-752e-a336-99997ad31787.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-4802-752e-a336-99997ad31787",
        "storage_key": "property/6767906449167608/019fc987-4802-752e-a336-99997ad31787.webp",
        "width": 1170,
        "height": 797
      },
      "poi_business_url": "https://www.visitthemap.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9011883457387750483&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-at-prairiefire",
      "poi_latitude": "38.8819446",
      "poi_longitude": "-94.6520905",
      "poi_miles_from_property": "11.6",
      "poi_walking_minutes": "4 hours 17 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 913-333-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcf3-7328-aa46-ca8b173bd882.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcf3-7328-aa46-ca8b173bd882",
        "storage_key": "property/6767906449167608/019fc984-fcf3-7328-aa46-ca8b173bd882.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJOdDvHPHBwIcRU-TQ6kGkEH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_840f28b8-407c-43de-8b02-de5545091c10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Prairiefire",
      "poi_type": "Shopping & Retail",
      "poi_address": "5661 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Unique entertainment venue with a shopping mall, museum exhibits & a self-guided wetlands trail.",
      "poi_long_description": "Unique entertainment venue with a shopping mall, museum exhibits & a self-guided wetlands trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a01012-fa13-759e-ad00-4dd974203776.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01012-fa13-759e-ad00-4dd974203776",
        "storage_key": "property/6767906449167608/01a01012-fa13-759e-ad00-4dd974203776.webp",
        "width": 1280,
        "height": 807
      },
      "poi_business_url": "http://prairiefireop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10467907726029435577&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prairiefire",
      "poi_latitude": "38.8827368",
      "poi_longitude": "-94.6507027",
      "poi_miles_from_property": "11.7",
      "poi_walking_minutes": "4 hours 19 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 913-338-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fccb-73cd-bdc9-5da275746b7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fccb-73cd-bdc9-5da275746b7f",
        "storage_key": "property/6767906449167608/019fc984-fccb-73cd-bdc9-5da275746b7f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJMcRmTvDBwIcRuTKNj516RZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_a8052e78-1056-46af-8b6b-af28173b74f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Chicken N Pickle - Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "5901 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Family-friendly venue with pickleball courts and other games, plus a casual restaurant.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc987-5e02-744e-a3ec-410ad13b2332.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-5e02-744e-a3ec-410ad13b2332",
        "storage_key": "property/6767906449167608/019fc987-5e02-744e-a3ec-410ad13b2332.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://chickennpickle.com/location/overland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3904135511973972812&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chicken-n-pickle---overland-park",
      "poi_latitude": "38.8830518",
      "poi_longitude": "-94.6552102",
      "poi_miles_from_property": "11.4",
      "poi_walking_minutes": "4 hours 13 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-703-5950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fce6-7730-b10a-74fed820d2e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fce6-7730-b10a-74fed820d2e7",
        "storage_key": "property/6767906449167608/019fc984-fce6-7730-b10a-74fed820d2e7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ9D8rijBwIcRTEsyKpBGLjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_6a22f452-81fc-4f85-b5a4-67b513263921",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "The Theatre in the Park",
      "poi_type": "Entertainment",
      "poi_address": "7710 Renner Rd, Shawnee, KS 66218, USA",
      "poi_short_description": "Sizable outdoor amphitheater featuring a lineup of Broadway-style musicals during the summer.",
      "poi_long_description": "Sizable outdoor amphitheater featuring a lineup of Broadway-style musicals during the summer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a01012-fb49-7385-8c47-8e36e550e113.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01012-fb49-7385-8c47-8e36e550e113",
        "storage_key": "property/6767906449167608/01a01012-fb49-7385-8c47-8e36e550e113.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.theatreinthepark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5677368960127881662&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-theatre-in-the-park",
      "poi_latitude": "38.9902381",
      "poi_longitude": "-94.7870635",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-826-3012",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcbc-744b-be91-9b2ee9935387.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcbc-744b-be91-9b2ee9935387",
        "storage_key": "property/6767906449167608/019fc984-fcbc-744b-be91-9b2ee9935387.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIxRjYZeTwIcRvlFAP_0Qyk4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amphitheatre"
    },
    {
      "id": "custom_b3da4822-5563-48f3-991a-c85812c50110",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Shawnee Mission Park - Visitor Services",
      "poi_type": "Entertainment",
      "poi_address": "7900 Renner Rd Visitor Center, Shawnee, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a01012-f96a-744d-85f1-4224d0a83adb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01012-f96a-744d-85f1-4224d0a83adb",
        "storage_key": "property/6767906449167608/01a01012-f96a-744d-85f1-4224d0a83adb.webp",
        "width": 1280,
        "height": 635
      },
      "poi_business_url": "https://www.jcprd.com/606/Visitor-Services",
      "poi_directions_map_url": "https://maps.google.com/?cid=15068624074064684319&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shawnee-mission-park---visitor-services",
      "poi_latitude": "38.9857532",
      "poi_longitude": "-94.7820515",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-438-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcbc-744b-be91-9b2ee9935387.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcbc-744b-be91-9b2ee9935387",
        "storage_key": "property/6767906449167608/019fc984-fcbc-744b-be91-9b2ee9935387.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE0oKYO-TwIcRH2WGJMKBHtE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "visitor_center"
    },
    {
      "id": "custom_39381efc-126c-4b2d-aa22-b70679cb4957",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Deanna Rose Children's Farmstead",
      "poi_type": "Entertainment",
      "poi_address": "13800 Switzer Rd, Overland Park, KS 66221, USA",
      "poi_short_description": "Spacious farmstead featuring replicas of life on the prairie, an ice cream parlor & wagon rides.",
      "poi_long_description": "Spacious farmstead featuring replicas of life on the prairie, an ice cream parlor & wagon rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc987-5cc2-741f-90ce-bb2c9bb2629c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-5cc2-741f-90ce-bb2c9bb2629c",
        "storage_key": "property/6767906449167608/019fc987-5cc2-741f-90ce-bb2c9bb2629c.webp",
        "width": 640,
        "height": 349
      },
      "poi_business_url": "http://www.opkansas.org/things-to-see-and-do/deanna-rose-childrens-farmstead/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7835830010939554497&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deanna-rose-childrens-farmstead",
      "poi_latitude": "38.877729",
      "poi_longitude": "-94.703345",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 913-897-2360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcbc-744b-be91-9b2ee9935387.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcbc-744b-be91-9b2ee9935387",
        "storage_key": "property/6767906449167608/019fc984-fcbc-744b-be91-9b2ee9935387.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt6IUwjvAwIcRwbplAuF1vmw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_dc8c5beb-19ad-43e8-a6f8-17435e170d60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Topgolf Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "10611 Nall Ave, Overland Park, KS 66207, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc987-6185-7629-bfc6-cd7fcbc651d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-6185-7629-bfc6-cd7fcbc651d1",
        "storage_key": "property/6767906449167608/019fc987-6185-7629-bfc6-cd7fcbc651d1.webp",
        "width": 1280,
        "height": 884
      },
      "poi_business_url": "https://topgolf.com/us/overland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4737452325202402593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-overland-park",
      "poi_latitude": "38.9364597",
      "poi_longitude": "-94.64818",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 17 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-562-9713",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fce6-7730-b10a-74fed820d2e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fce6-7730-b10a-74fed820d2e7",
        "storage_key": "property/6767906449167608/019fc984-fce6-7730-b10a-74fed820d2e7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJibz1RyvqwIcRIZ0JKMrPvkE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_592aed29-2afb-4b8f-acf0-99a149691bdf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "AdventHealth Lenexa City Center",
      "poi_type": "Health and Wellness",
      "poi_address": "16950 W 86th St, Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc987-8300-725f-84fb-7123c6ca2560.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-8300-725f-84fb-7123c6ca2560",
        "storage_key": "property/6767906449167608/019fc987-8300-725f-84fb-7123c6ca2560.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.adventhealth.com/hospital/adventhealth-lenexa-city-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=3493847724923958515&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adventhealth-lenexa-city-center",
      "poi_latitude": "38.9735565",
      "poi_longitude": "-94.7814099",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-934-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcfe-776a-84ab-bae6ffad5fea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcfe-776a-84ab-bae6ffad5fea",
        "storage_key": "property/6767906449167608/019fc984-fcfe-776a-84ab-bae6ffad5fea.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJBWBnD1uVwIcR8zRmn_6jfDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_02d16afa-202e-421f-8391-f497cd094360",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Overland Park Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "10500 Quivira Rd, Overland Park, KS 66215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-ebbb-701d-b27d-f2d424f0384d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc984-ebbb-701d-b27d-f2d424f0384d",
        "storage_key": "property/6767906449167608/019fc984-ebbb-701d-b27d-f2d424f0384d.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.hcamidwest.com/locations/overland-park-regional-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13555409796355494155&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-park-regional-medical-center",
      "poi_latitude": "38.9376197",
      "poi_longitude": "-94.7261812",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-541-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcfe-776a-84ab-bae6ffad5fea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcfe-776a-84ab-bae6ffad5fea",
        "storage_key": "property/6767906449167608/019fc984-fcfe-776a-84ab-bae6ffad5fea.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4cFCWJzAwIcRC5Ge4GN9Hrw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_23c2c43f-be13-42f4-9b0b-a35d277dabdc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "MISH Hospital and Clinics",
      "poi_type": "Health and Wellness",
      "poi_address": "10951 Lakeview Ave, Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc987-5f0d-7582-83ce-6182c03ac0d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-5f0d-7582-83ce-6182c03ac0d8",
        "storage_key": "property/6767906449167608/019fc987-5f0d-7582-83ce-6182c03ac0d8.webp",
        "width": 786,
        "height": 840
      },
      "poi_business_url": "http://www.mishhospital.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12347913264350086951&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mish-hospital-and-clinics",
      "poi_latitude": "38.9293697",
      "poi_longitude": "-94.7686414",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-322-7408",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcfe-776a-84ab-bae6ffad5fea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcfe-776a-84ab-bae6ffad5fea",
        "storage_key": "property/6767906449167608/019fc984-fcfe-776a-84ab-bae6ffad5fea.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJg-LUgQeVwIcRJ8frHrGZXKs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_3ad39617-a1b9-4b8c-a306-cc96b1c6ed33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "CareNow Urgent Care - Lenexa",
      "poi_type": "Health and Wellness",
      "poi_address": "15421 W 87th St Pkwy, Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc987-629e-778f-9bdd-2c27c00be658.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-629e-778f-9bdd-2c27c00be658",
        "storage_key": "property/6767906449167608/019fc987-629e-778f-9bdd-2c27c00be658.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.carenow.com/locations/kansas-city/lenexa?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1686808750833078671&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---lenexa",
      "poi_latitude": "38.9706195",
      "poi_longitude": "-94.76521780000002",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-320-4060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcbc-744b-be91-9b2ee9935387.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcbc-744b-be91-9b2ee9935387",
        "storage_key": "property/6767906449167608/019fc984-fcbc-744b-be91-9b2ee9935387.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ47eN6vKVwIcRjxFtLZ-_aBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_5ad8d88a-8ff3-4b32-aa48-9ce8dcf7d32a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "13502 W 87th St Pkwy, Lenexa, KS 66215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc987-3f94-704f-93db-25feb7dbd85b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-3f94-704f-93db-25feb7dbd85b",
        "storage_key": "property/6767906449167608/019fc987-3f94-704f-93db-25feb7dbd85b.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/lenexa-ks-pharmacies/13502-west-87th-street-parkway-lenexa-ks-66215/storeid=5265?WT.mc_id=LS_GOOGLE_RX_5265",
      "poi_directions_map_url": "https://maps.google.com/?cid=10706818752355258298&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "38.9717631",
      "poi_longitude": "-94.7430337",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-492-4650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc988-070a-7365-9927-42c2542c2adc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc988-070a-7365-9927-42c2542c2adc",
        "storage_key": "property/6767906449167608/019fc988-070a-7365-9927-42c2542c2adc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJebIe0qaUwIcRuk-gmO1ClpQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_65b7c4fe-5eb9-4317-9856-f68c63889606",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "16851 W 90th St, Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-e25f-72e3-90ea-7a22811ab1b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc984-e25f-72e3-90ea-7a22811ab1b6",
        "storage_key": "property/6767906449167608/019fc984-e25f-72e3-90ea-7a22811ab1b6.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/ks/lenexa?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=2747436863078274604&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "38.9641885",
      "poi_longitude": "-94.7812141",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 913-888-2211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcbc-744b-be91-9b2ee9935387.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcbc-744b-be91-9b2ee9935387",
        "storage_key": "property/6767906449167608/019fc984-fcbc-744b-be91-9b2ee9935387.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSVr6fHCUwIcRLBaYOkXbICY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f575badc-3c53-4293-a290-e08dc7265fb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Lenexa Rec Center",
      "poi_type": "Health and Wellness",
      "poi_address": "17201 W 87th St Pkwy, Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc987-71da-7774-9fe8-f5a201b55d60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-71da-7774-9fe8-f5a201b55d60",
        "storage_key": "property/6767906449167608/019fc987-71da-7774-9fe8-f5a201b55d60.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.lenexa.com/Parks-Places/Rec-Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=11172866499214267837&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lenexa-rec-center",
      "poi_latitude": "38.9697275",
      "poi_longitude": "-94.7854454",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-477-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcbc-744b-be91-9b2ee9935387.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcbc-744b-be91-9b2ee9935387",
        "storage_key": "property/6767906449167608/019fc984-fcbc-744b-be91-9b2ee9935387.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJga7m1XWUwIcRvVWHeOL-DZs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_99932942-c7af-4cba-b5aa-13e3175b5d6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Club Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "16131 W 87th St Pkwy, Lenexa, KS 66219, USA",
      "poi_short_description": "Studio offering group Pilates classes, including Reformer-based workouts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc987-7570-73cd-a34d-f77d6b27997a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-7570-73cd-a34d-f77d6b27997a",
        "storage_key": "property/6767906449167608/019fc987-7570-73cd-a34d-f77d6b27997a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.clubpilates.com/location/lenexa/?utm_source=google.com&utm_medium=referral&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=14325566862800400585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "club-pilates",
      "poi_latitude": "38.9697516",
      "poi_longitude": "-94.7729271",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-499-6453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcbd-7378-a1a9-579b1c785c50.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcbd-7378-a1a9-579b1c785c50",
        "storage_key": "property/6767906449167608/019fc984-fcbd-7378-a1a9-579b1c785c50.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJm0RGAPSVwIcRyTBTXymjzsY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_3d51ebea-6b25-48b8-b8cb-bc3d0d2577dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "17140 W 87th St, Lenexa, KS 66219, USA",
      "poi_short_description": "Chain gym offering group cardio and strength training workouts tailored to fitness level.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc987-7a75-7668-a7b9-dc7b6f7e84e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-7a75-7668-a7b9-dc7b6f7e84e7",
        "storage_key": "property/6767906449167608/019fc987-7a75-7668-a7b9-dc7b6f7e84e7.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/lenexa-kansas-0950?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=4102056260791528505&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "38.9712119",
      "poi_longitude": "-94.783979",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-712-0505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcbc-744b-be91-9b2ee9935387.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcbc-744b-be91-9b2ee9935387",
        "storage_key": "property/6767906449167608/019fc984-fcbc-744b-be91-9b2ee9935387.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt0FxtnWUwIcROWwlgW9u7Tg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_694dd985-66ab-4f27-9d95-65c35badf759",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Electric Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Loiret Blvd & West 95th Street, Electric Park, Lenexa, KS 66219, USA",
      "poi_short_description": "Park featuring a playground, sand volleyball courts, grassy space & a picnic shelter with grills.",
      "poi_long_description": "Park featuring a playground, sand volleyball courts, grassy space & a picnic shelter with grills.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc987-78e3-7091-8837-a35691d8151e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-78e3-7091-8837-a35691d8151e",
        "storage_key": "property/6767906449167608/019fc987-78e3-7091-8837-a35691d8151e.webp",
        "width": 889,
        "height": 500
      },
      "poi_business_url": "https://www.lenexa.com/Parks-Places/Parks-Outdoors/Parks/Electric-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=12601988370145179708&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "electric-park",
      "poi_latitude": "38.9589664",
      "poi_longitude": "-94.7694085",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-477-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcf8-74ce-95ee-b3140259ccd1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcf8-74ce-95ee-b3140259ccd1",
        "storage_key": "property/6767906449167608/019fc984-fcf8-74ce-95ee-b3140259ccd1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJlSI5eWKUwIcRPHgbiqdB464",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6e251756-7b6b-4052-91b0-b2ae0a2ef5ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Scouting Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Haskins St & W 94th St, Lenexa, KS 66215, USA",
      "poi_short_description": "Children's playground featuring swings, a zip line, and picnic tables.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc987-8438-715e-b5cd-1e4a9a365f8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-8438-715e-b5cd-1e4a9a365f8d",
        "storage_key": "property/6767906449167608/019fc987-8438-715e-b5cd-1e4a9a365f8d.webp",
        "width": 889,
        "height": 500
      },
      "poi_business_url": "https://www.lenexa.com/Parks-Places/Parks-Outdoors/Parks/Scouting-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16869115134783061126&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scouting-park",
      "poi_latitude": "38.95853719999999",
      "poi_longitude": "-94.7404872",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-477-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcf8-74ce-95ee-b3140259ccd1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcf8-74ce-95ee-b3140259ccd1",
        "storage_key": "property/6767906449167608/019fc984-fcf8-74ce-95ee-b3140259ccd1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvXFdmbmUwIcRhvzos9YiG-o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_90cb127a-3c5e-4ec5-9d1b-371a4a5a8daa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Lenexa City Center",
      "poi_type": "Entertainment",
      "poi_address": "8741 Ryckert St, Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc987-8b98-7492-84ef-b24a4c3b04d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-8b98-7492-84ef-b24a4c3b04d6",
        "storage_key": "property/6767906449167608/019fc987-8b98-7492-84ef-b24a4c3b04d6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10694621462734542941&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lenexa-city-center",
      "poi_latitude": "38.9687567",
      "poi_longitude": "-94.7776957",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcbc-744b-be91-9b2ee9935387.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcbc-744b-be91-9b2ee9935387",
        "storage_key": "property/6767906449167608/019fc984-fcbc-744b-be91-9b2ee9935387.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ09V90U-VwIcRXZiPzY7tapQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_a2498da0-f3b6-4733-bf2c-978948344908",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Tamarisk Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Lackman Rd &, W 91st Terrace, Lenexa, KS 66219, USA",
      "poi_short_description": "Kid-friendly space that features slides, a playhouse and picnic benches.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc987-8aef-7038-912a-5748700c1b24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-8aef-7038-912a-5748700c1b24",
        "storage_key": "property/6767906449167608/019fc987-8aef-7038-912a-5748700c1b24.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lenexa.com/Parks-Places/Parks-Outdoors/Parks/Tamarisk-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13109201770422041861&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tamarisk-park",
      "poi_latitude": "38.9633682",
      "poi_longitude": "-94.7609137",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-477-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcf8-74ce-95ee-b3140259ccd1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcf8-74ce-95ee-b3140259ccd1",
        "storage_key": "property/6767906449167608/019fc984-fcf8-74ce-95ee-b3140259ccd1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ39I-gY-UwIcRBX3t_o097bU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c9ef597b-d767-43ba-8851-4b9cdf1fa973",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Mill Creek Streamway Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10298 Ridgeview Rd, Lenexa, KS 66220, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a01013-01e8-728a-9f4b-bce799fd69c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01013-01e8-728a-9f4b-bce799fd69c1",
        "storage_key": "property/6767906449167608/01a01013-01e8-728a-9f4b-bce799fd69c1.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13696883745268866388&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mill-creek-streamway-park",
      "poi_latitude": "38.9532829",
      "poi_longitude": "-94.7977326",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcf8-74ce-95ee-b3140259ccd1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcf8-74ce-95ee-b3140259ccd1",
        "storage_key": "property/6767906449167608/019fc984-fcf8-74ce-95ee-b3140259ccd1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZy5tzMOVwIcRVJ2SdjIbFb4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_fec34a33-aef6-4800-8242-dea8d7ab933f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Central Green Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "W 87th St Pkwy, Lenexa, KS 66219, USA",
      "poi_short_description": "Peaceful green space favored for walking and jogging via trails near a creek.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019ff6ad-e21d-714a-8078-aeb400889cdb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-e21d-714a-8078-aeb400889cdb",
        "storage_key": "property/6767906449167608/019ff6ad-e21d-714a-8078-aeb400889cdb.webp",
        "width": 889,
        "height": 500
      },
      "poi_business_url": "https://www.lenexa.com/Parks-Places/Parks-Outdoors/Parks/Central-Green-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14123022230327547380&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-green-park",
      "poi_latitude": "38.97242019999999",
      "poi_longitude": "-94.7833393",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-477-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcf8-74ce-95ee-b3140259ccd1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcf8-74ce-95ee-b3140259ccd1",
        "storage_key": "property/6767906449167608/019fc984-fcf8-74ce-95ee-b3140259ccd1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGSm9UXaUwIcR9FWeOeQN_8M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1874576f-4efc-4ce8-a36a-4b8c053ad7a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Buffalo Meadows Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9650 Lone Elm Rd, Lenexa, KS 66220, USA",
      "poi_short_description": "Dog-friendly park on 20 acres with a picnic shelter & playgrounds, plus athletic fields & a trail.",
      "poi_long_description": "Dog-friendly park on 20 acres with a picnic shelter & playgrounds, plus athletic fields & a trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a01013-02c9-769b-a414-464ba2e9ae1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01013-02c9-769b-a414-464ba2e9ae1b",
        "storage_key": "property/6767906449167608/01a01013-02c9-769b-a414-464ba2e9ae1b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lenexa.com/Parks-Places/Parks-Outdoors/Parks/Buffalo-Meadows-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2495183704965201071&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buffalo-meadows-park",
      "poi_latitude": "38.9535082",
      "poi_longitude": "-94.8371574",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-477-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcf8-74ce-95ee-b3140259ccd1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcf8-74ce-95ee-b3140259ccd1",
        "storage_key": "property/6767906449167608/019fc984-fcf8-74ce-95ee-b3140259ccd1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5yaz0cOWwIcRrzzLD1ysoCI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_402680f5-e3fa-4c4e-a882-7d1df7ecbe59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Sar-Ko-Par Trails Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "and West 87th Street Parkway, Lackman Rd, Lenexa, KS 66215, USA",
      "poi_short_description": "Large park featuring trails, sports fields, a disc-golf course & playgrounds, plus a historic barn.",
      "poi_long_description": "Large park featuring trails, sports fields, a disc-golf course & playgrounds, plus a historic barn.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-f20f-72af-a6b7-cdc5dfddca4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc984-f20f-72af-a6b7-cdc5dfddca4a",
        "storage_key": "property/6767906449167608/019fc984-f20f-72af-a6b7-cdc5dfddca4a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lenexa.com/Parks-Places/Parks-Outdoors/Parks/Sar-Ko-Par-Trails-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2823848540526094805&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sar-ko-par-trails-park",
      "poi_latitude": "38.9703123",
      "poi_longitude": "-94.7585845",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-477-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcf8-74ce-95ee-b3140259ccd1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcf8-74ce-95ee-b3140259ccd1",
        "storage_key": "property/6767906449167608/019fc984-fcf8-74ce-95ee-b3140259ccd1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJWwHgcJyUwIcR1SmQRUlTMCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_eedf7db5-0814-46bf-aa20-bae72bdebb5c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Flat Rock Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "W 103rd St & Hauser St, 13120 103rd St, Lenexa, KS 66215, USA",
      "poi_short_description": "Shaded park featuring a pool, a creek and a kids' playground.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a01012-fda0-70fc-94ec-6006b1fe5018.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01012-fda0-70fc-94ec-6006b1fe5018",
        "storage_key": "property/6767906449167608/01a01012-fda0-70fc-94ec-6006b1fe5018.webp",
        "width": 889,
        "height": 500
      },
      "poi_business_url": "https://www.lenexa.com/Parks-Places/Parks-Outdoors/Parks/Flat-Rock-Creek-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9623185102105369747&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flat-rock-creek-park",
      "poi_latitude": "38.9420315",
      "poi_longitude": "-94.7380203",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-477-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcf8-74ce-95ee-b3140259ccd1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcf8-74ce-95ee-b3140259ccd1",
        "storage_key": "property/6767906449167608/019fc984-fcf8-74ce-95ee-b3140259ccd1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJq7j0bdCUwIcRk1zSUt1rjIU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c4a46665-58f9-4b66-9a95-ea8abffef781",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Black Hoof Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9053 Monticello Rd, Lenexa, KS 66220, USA",
      "poi_short_description": "A 160-acre park featuring diverse wildlife, trails, picnic shelter, playground & lake activities.",
      "poi_long_description": "A 160-acre park featuring diverse wildlife, trails, picnic shelter, playground & lake activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-efbd-75bd-88ff-c333a47d1db6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc984-efbd-75bd-88ff-c333a47d1db6",
        "storage_key": "property/6767906449167608/019fc984-efbd-75bd-88ff-c333a47d1db6.webp",
        "width": 889,
        "height": 500
      },
      "poi_business_url": "https://www.lenexa.com/Parks-Places/Parks-Outdoors/Parks/Black-Hoof-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=4061609937874123912&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black-hoof-park",
      "poi_latitude": "38.9651518",
      "poi_longitude": "-94.8440674",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-477-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcf8-74ce-95ee-b3140259ccd1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcf8-74ce-95ee-b3140259ccd1",
        "storage_key": "property/6767906449167608/019fc984-fcf8-74ce-95ee-b3140259ccd1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJD5faIc6WwIcRiPwuG7i8XTg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8626720d-42b2-4a1b-8cd2-4d8db27d0c2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Oak Park Mall Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Overland Park, KS 66214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16122160475460681538&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-park-mall-park--ride",
      "poi_latitude": "38.9552209",
      "poi_longitude": "-94.7216049",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc988-07d7-71ec-a24c-c0336514620b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc988-07d7-71ec-a24c-c0336514620b",
        "storage_key": "property/6767906449167608/019fc988-07d7-71ec-a24c-c0336514620b.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJVwpg4UnrwIcRQj-tl4hrvd8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_7ab48e41-d3da-44fd-9711-6e398d589277",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Parking Garage at Midwest Trust Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Unnamed Road, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14057951358565302707&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parking-garage-at-midwest-trust-center",
      "poi_latitude": "38.9259805",
      "poi_longitude": "-94.7269763",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc988-07d7-71ec-a24c-c0336514620b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc988-07d7-71ec-a24c-c0336514620b",
        "storage_key": "property/6767906449167608/019fc988-07d7-71ec-a24c-c0336514620b.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9ecDBE_rwIcRs0EBRUfgF8M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_6474c458-0433-40c2-a250-5482ce559d1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Mission Transit Center Bay #6",
      "poi_type": "Transportation & Transit",
      "poi_address": "5251 Johnson Dr, Mission, KS 66205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10549898407240321397&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mission-transit-center-bay-6",
      "poi_latitude": "39.0225898",
      "poi_longitude": "-94.6455458",
      "poi_miles_from_property": "10.7",
      "poi_walking_minutes": "3 hours 58 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a01013-0ea3-7258-861b-d6a6d45ace5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01013-0ea3-7258-861b-d6a6d45ace5c",
        "storage_key": "property/6767906449167608/01a01013-0ea3-7258-861b-d6a6d45ace5c.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJExGkd9XtwIcRdckEpLTEaJI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "custom_28f3b3ad-a23e-4cf5-ba19-4dbc79c8553c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Kansas City International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Kansas City Blvd, Kansas City, MO 64153, USA",
      "poi_short_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_long_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc987-ada8-7342-8cb9-735ff52ad071.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-ada8-7342-8cb9-735ff52ad071",
        "storage_key": "property/6767906449167608/019fc987-ada8-7342-8cb9-735ff52ad071.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.flykc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14109162014977743520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-international-airport",
      "poi_latitude": "39.3014091",
      "poi_longitude": "-94.7104536",
      "poi_miles_from_property": "38.2",
      "poi_walking_minutes": "14 hours 10 mins",
      "poi_biking_minutes": "4 hours 3 mins",
      "poi_driving_minutes": "35 mins",
      "poi_business_phone": "+1 816-243-5237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-ff4e-777a-9850-07c3c5729255.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-ff4e-777a-9850-07c3c5729255",
        "storage_key": "property/6767906449167608/019fc984-ff4e-777a-9850-07c3c5729255.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJmYfmiAhewIcRoNouXRnQzcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_4b023dc8-e76b-4247-b6e3-3a30ebac4e35",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Quest Diagnostics",
      "poi_type": "Health and Wellness",
      "poi_address": "Psc, 10101 Renner Blvd 1st Floor, Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc987-e5e2-774e-97b4-98c7abf70292.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-e5e2-774e-97b4-98c7abf70292",
        "storage_key": "property/6767906449167608/019fc987-e5e2-774e-97b4-98c7abf70292.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.questdiagnostics.com/ks/lenexa/10101-renner-blvd",
      "poi_directions_map_url": "https://maps.google.com/?cid=8308711658607195254&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quest-diagnostics",
      "poi_latitude": "38.946177",
      "poi_longitude": "-94.776076",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-577-1770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcbc-744b-be91-9b2ee9935387.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcbc-744b-be91-9b2ee9935387",
        "storage_key": "property/6767906449167608/019fc984-fcbc-744b-be91-9b2ee9935387.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrdOOCVuUwIcRdrRtaDt5TnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_lab"
    },
    {
      "id": "custom_3a767f4f-b74e-4fbd-800d-802e124e43fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Amazon MCI5",
      "poi_type": "Major Employers & Offices",
      "poi_address": "16851 W 113th St, Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc987-bf45-73fb-8d8e-588a6b45a70e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-bf45-73fb-8d8e-588a6b45a70e",
        "storage_key": "property/6767906449167608/019fc987-bf45-73fb-8d8e-588a6b45a70e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://amazon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17188903443457799781&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amazon-mci5",
      "poi_latitude": "38.921271",
      "poi_longitude": "-94.782689",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 855-254-8971",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcbc-744b-be91-9b2ee9935387.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcbc-744b-be91-9b2ee9935387",
        "storage_key": "property/6767906449167608/019fc984-fcbc-744b-be91-9b2ee9935387.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKxK666-VwIcRZXbKcZxAi-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "custom_0ef77d85-1d8e-4c6f-89e4-d177a333692a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "JCPenney Distribution Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "10500 Lackman Rd, Lenexa, KS 66219, USA",
      "poi_short_description": "Chain department store selling a wide selection of brand-name clothing, footwear, furniture & more.",
      "poi_long_description": "Chain department store selling a wide selection of brand-name clothing, footwear, furniture & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a01013-0703-736f-af2c-87f50a64ce3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01013-0703-736f-af2c-87f50a64ce3d",
        "storage_key": "property/6767906449167608/01a01013-0703-736f-af2c-87f50a64ce3d.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://www.jcpenney.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2733105575562216438&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jcpenney-distribution-center",
      "poi_latitude": "38.9377289",
      "poi_longitude": "-94.76588970000002",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-492-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcbc-744b-be91-9b2ee9935387.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcbc-744b-be91-9b2ee9935387",
        "storage_key": "property/6767906449167608/019fc984-fcbc-744b-be91-9b2ee9935387.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-TKutviUwIcR9oMGVQrx7SU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "custom_12090ed2-ceca-4d4d-b701-2d05a9d6a7a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Rockwell Collins - Lenexa",
      "poi_type": "Transportation & Transit",
      "poi_address": "15701 W 95th St, Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a01013-037b-7147-ba3b-3c5d71789153.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01013-037b-7147-ba3b-3c5d71789153",
        "storage_key": "property/6767906449167608/01a01013-037b-7147-ba3b-3c5d71789153.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.collinsaerospace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13042005669828156951&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rockwell-collins---lenexa",
      "poi_latitude": "38.9554245",
      "poi_longitude": "-94.7686381",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-338-9800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcbc-744b-be91-9b2ee9935387.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcbc-744b-be91-9b2ee9935387",
        "storage_key": "property/6767906449167608/019fc984-fcbc-744b-be91-9b2ee9935387.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx0FENSeVwIcRF968pA6D_rQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_1e9c614e-8287-40bf-b15b-0b1380893cbc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Grundfos",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9300 Loiret Blvd, Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019ff6ad-f474-775a-968e-5427e40099a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-f474-775a-968e-5427e40099a3",
        "storage_key": "property/6767906449167608/019ff6ad-f474-775a-968e-5427e40099a3.webp",
        "width": 680,
        "height": 510
      },
      "poi_business_url": "https://www.grundfos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8014934474911703211&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grundfos",
      "poi_latitude": "38.959381",
      "poi_longitude": "-94.7716232",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 844-403-1543",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcbc-744b-be91-9b2ee9935387.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcbc-744b-be91-9b2ee9935387",
        "storage_key": "property/6767906449167608/019fc984-fcbc-744b-be91-9b2ee9935387.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi8nfmQ2VwIcRq-Ako3DEOm8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4bb5adba-159c-4bb5-b47c-8a701ee5629d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "National Archives at Lenexa",
      "poi_type": "Major Employers & Offices",
      "poi_address": "17501 W 98th St, Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a01013-06f3-7259-85e0-69491cb01d82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01013-06f3-7259-85e0-69491cb01d82",
        "storage_key": "property/6767906449167608/01a01013-06f3-7259-85e0-69491cb01d82.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.archives.gov/frc/lenexa",
      "poi_directions_map_url": "https://maps.google.com/?cid=1902620408862951350&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "national-archives-at-lenexa",
      "poi_latitude": "38.95271169999999",
      "poi_longitude": "-94.791861",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-563-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-ff58-72e7-8d30-1842ca425243.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-ff58-72e7-8d30-1842ca425243",
        "storage_key": "property/6767906449167608/019fc984-ff58-72e7-8d30-1842ca425243.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5Re6ehWUwIcRtkevbC53Zxo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_defe8655-d527-4a1b-8f8d-622f2144a2ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "UPS Customer Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "W6MV+MQ LENKS, 14650 Santa Fe Trail Dr, Lenexa, KS 66215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc987-e63b-77ce-9f83-325f696381f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-e63b-77ce-9f83-325f696381f3",
        "storage_key": "property/6767906449167608/019fc987-e63b-77ce-9f83-325f696381f3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.ups.com/us/en/ks/lenexa/customer-center-008711.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=15825102030431012940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ups-customer-center",
      "poi_latitude": "38.931486",
      "poi_longitude": "-94.7560946",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 888-742-5877",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcbc-744b-be91-9b2ee9935387.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcbc-744b-be91-9b2ee9935387",
        "storage_key": "property/6767906449167608/019fc984-fcbc-744b-be91-9b2ee9935387.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkRzcnuKUwIcRTEgnonMOnts",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shipping_service"
    },
    {
      "id": "custom_87373aa6-c5cf-41e3-99d9-98249211ded0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "Black & Veatch",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11401 Lamar Ave, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc987-dcda-7419-a0c2-afbc34860c28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-dcda-7419-a0c2-afbc34860c28",
        "storage_key": "property/6767906449167608/019fc987-dcda-7419-a0c2-afbc34860c28.webp",
        "width": 1280,
        "height": 653
      },
      "poi_business_url": "http://www.bv.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15245877116558125981&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black--veatch",
      "poi_latitude": "38.9250015",
      "poi_longitude": "-94.6553624",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-458-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcbc-744b-be91-9b2ee9935387.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcbc-744b-be91-9b2ee9935387",
        "storage_key": "property/6767906449167608/019fc984-fcbc-744b-be91-9b2ee9935387.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUyTe2TrqwIcRnSu0HXY8lNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "custom_5a9e85de-3a7e-4bdf-aab9-8e3d552d84b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "custom",
      "poi_name": "T-Mobile Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6220 Sprint Pkwy, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019ff6d8-428d-713e-9fd5-c07b7bc2791c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6d8-428d-713e-9fd5-c07b7bc2791c",
        "storage_key": "property/6767906449167608/019ff6d8-428d-713e-9fd5-c07b7bc2791c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16065491002476993060&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "t-mobile-corporate-office",
      "poi_latitude": "38.9158914",
      "poi_longitude": "-94.6621181",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 855-977-5086",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/019fc984-fcbc-744b-be91-9b2ee9935387.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc984-fcbc-744b-be91-9b2ee9935387",
        "storage_key": "property/6767906449167608/019fc984-fcbc-744b-be91-9b2ee9935387.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI0P_xjzrwIcRJBrguPIW9N4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_864a6c9106426f151059a9b1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_518e1ecb13f0f684824d5db6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_ae94e5c1027f1074fb256939",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_72048b990f14754cbdd2573b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_aee8b959a4f2e44f7b802f50",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_df1ab027f3610b4d3a8f4a1a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_91e227acdfe39afb2aa58457",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "rating": "5",
      "name": "Abe Stephenson",
      "text": "Maintenance is very quick when we had a minor emergency. Management is helpful and professional in the time ive been here. The apartments are very nice. Rent for the square footage is a bit high but the location and community make up for that.\n\nWe also have an amazing management team and property manager. Me and my fiance have had issues with one \"unusually grumpy\" neighbor and any time I've had concerns brought up they've handled it wonderfully. Everyone else around this community is extremely kind so don't let that dissuade you from living here.\n\nI highly recommended this apartment for anyone wanting a first apartment in the Lenexa area. Make sure to utilize the pool & the nice trails all around the area.",
      "date": "2025-10-14",
      "title": "false"
    },
    {
      "id": "ec_5905e62c41dad1797513f31e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "rating": "5",
      "name": "Esmeralda Peaches",
      "text": "I wanted to take a moment to recognize Hannah for the exceptional service she provided while helping us find our new apartment.\n\nFrom start to finish, Hannah was professional, attentive, and genuinely invested in making sure we found the right place. She took the time to understand exactly what we were looking for, stayed patient through our questions, and consistently went above and beyond to make the process smooth and stress-free.\n\nWhat really stood out was her work ethic and attention to detail. She was always responsive, organized, and proactive—keeping us informed every step of the way and making sure nothing fell through the cracks. It’s clear that she takes pride in her work and truly cares about the people she’s helping.\n\nBecause of Hannah, what could have been a stressful experience turned into an easy and positive one. She is an incredible asset to your team, and I sincerely hope her hard work and dedication are recognized.\n\nThank you again for having someone like Hannah on your team.",
      "date": "2026-04-27",
      "title": "false"
    },
    {
      "id": "ec_0383992524113977f9e9e990",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "rating": "5",
      "name": "Debesaibanks5",
      "text": "Me and my wife love this place, and we appreciate them very much. Kevin is one of the hardest working maintenance men I know, he does ALOT for this community and is a great guy. He is dedicated to his position and does it with greatness.",
      "date": "2026-06-12",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_45df624c787ad3eeed0da991",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b604-4c29-7440-8efd-facad9b3e3b2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b604-4c29-7440-8efd-facad9b3e3b2",
        "storage_key": "property/6767906449167608/01a0b604-4c29-7440-8efd-facad9b3e3b2.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Medina",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Bge1E57CNUw"
    },
    {
      "id": "ec_5b6e5bbd41a73131faca605a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b604-339a-701d-9216-3f73497d0be7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b604-339a-701d-9216-3f73497d0be7",
        "storage_key": "property/6767906449167608/01a0b604-339a-701d-9216-3f73497d0be7.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Medina II",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=rrQHimy83NZ"
    },
    {
      "id": "ec_e480189960ffeea0b5d8c75f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b604-3441-737a-801d-26a26732064d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b604-3441-737a-801d-26a26732064d",
        "storage_key": "property/6767906449167608/01a0b604-3441-737a-801d-26a26732064d.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Rio",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=1Jgp7KrmTaE"
    },
    {
      "id": "ec_119c8eb5c84190e12fce3fb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b604-34cb-70b3-a5a2-be0afe2e0230.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b604-34cb-70b3-a5a2-be0afe2e0230",
        "storage_key": "property/6767906449167608/01a0b604-34cb-70b3-a5a2-be0afe2e0230.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Rio II",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=u6rYf7khqwB"
    },
    {
      "id": "ec_635fffb239ebe93270bec2a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b604-394b-7282-9c8c-781d49efcff6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b604-394b-7282-9c8c-781d49efcff6",
        "storage_key": "property/6767906449167608/01a0b604-394b-7282-9c8c-781d49efcff6.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Cimmaron",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=imkxhAAfRqu"
    },
    {
      "id": "ec_5c845129c5cd37688b6bb847",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b604-5dc7-704e-aafe-ae1fa1549e7f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b604-5dc7-704e-aafe-ae1fa1549e7f",
        "storage_key": "property/6767906449167608/01a0b604-5dc7-704e-aafe-ae1fa1549e7f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Cimmaron II",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=fihe9mhmVsm"
    },
    {
      "id": "ec_93c5cf59abd0a3325cda5ca6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b604-5400-72be-b1d1-2f36458cccee.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b604-5400-72be-b1d1-2f36458cccee",
        "storage_key": "property/6767906449167608/01a0b604-5400-72be-b1d1-2f36458cccee.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Sheyenne",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=LJd6mKFiSLV"
    },
    {
      "id": "ec_480bdccb9bee1bcb1ab2ca08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b604-5f8e-757c-a664-35ba1260ce03.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b604-5f8e-757c-a664-35ba1260ce03",
        "storage_key": "property/6767906449167608/01a0b604-5f8e-757c-a664-35ba1260ce03.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Sheyenne II",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=psd1PYHmjsE"
    },
    {
      "id": "ec_cc26147388cb4f695f20e459",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b604-5e0d-7048-ba40-80a3d9ad5e8d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b604-5e0d-7048-ba40-80a3d9ad5e8d",
        "storage_key": "property/6767906449167608/01a0b604-5e0d-7048-ba40-80a3d9ad5e8d.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Cascade",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Ge71mpQQHFf"
    },
    {
      "id": "ec_f42eb030bc0c0180699e9383",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b604-7258-7399-b566-a7608571b473.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b604-7258-7399-b566-a7608571b473",
        "storage_key": "property/6767906449167608/01a0b604-7258-7399-b566-a7608571b473.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Savanna",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=rRHi9LgAB37"
    },
    {
      "id": "ec_3412ac2153afca9750feed2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b604-7f62-74dc-b8eb-1822289d89c4.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b604-7f62-74dc-b8eb-1822289d89c4",
        "storage_key": "property/6767906449167608/01a0b604-7f62-74dc-b8eb-1822289d89c4.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Savanna II",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=UbKAgvjwySK"
    },
    {
      "id": "ec_981ba0705b5415860dd3140b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b604-8665-7364-b57c-e121387d9542.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b604-8665-7364-b57c-e121387d9542",
        "storage_key": "property/6767906449167608/01a0b604-8665-7364-b57c-e121387d9542.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Prairie",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=xLQG89b2ZeW"
    },
    {
      "id": "ec_cacad221d08fffae25b8fd93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b604-7f9c-707a-8143-7b7f5ab20579.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b604-7f9c-707a-8143-7b7f5ab20579",
        "storage_key": "property/6767906449167608/01a0b604-7f9c-707a-8143-7b7f5ab20579.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Prairie II",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=nNTuoUP8mFJ"
    },
    {
      "id": "ec_c251e0a1d63ba019524e76c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Prairie Creek - Townhome - 3 beds, 2.5+ bathrooms, 2000+ sqft.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167608/01a0b604-819f-731f-b2a7-5f36a15d2dd8.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b604-819f-731f-b2a7-5f36a15d2dd8",
        "storage_key": "property/6767906449167608/01a0b604-819f-731f-b2a7-5f36a15d2dd8.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Townhome",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=fqPYhphF3Tg"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0c9ac-3f77-7495-9e73-8d9e63823ca1",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Prairie Creek Apartments & Townhomes Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608"
    },
    {
      "lead_collector_id": "01a0c9ac-3ff0-75ca-ab28-d83a10ccf389",
      "lead_source": "LANDING_PAGE",
      "name": "Prairie Creek Apartments & Townhomes Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "generator",
      "page_item_url": "luxury-apartments-lenexa-with-pool",
      "search_query": "luxury apartments Lenexa with pool",
      "category": "Amenity",
      "h1_title": "Luxury Apartments Lenexa with Pool",
      "h2_subtitle": "Discover our luxury apartments in Lenexa featuring a stunning pool and expansive living options. Enjoy resort-style amenities in your new home.",
      "page_copy": "Experience the pinnacle of luxury living at Prairie Creek Apartments & Townhomes in Lenexa, where you’ll find spacious layouts and high-end finishes. Our community homes are perfect for those seeking luxury apartments in Lenexa with pool access. Dive into relaxation in our impressive pool area, designed to offer a resort-style experience right at your doorstep.\n\nLocated in the serene Outlying Johnson County, KS, Prairie Creek combines convenience with elegance. Our amenities, including walking and biking trails, extra storage, and a dedicated personal trainer, complement our exquisite pool facility. Schedule a tour today and see why our luxury apartments in Lenexa stand a cut above the rest.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, adjacent to an outdoor kitchen and dining area.",
        "public_id": "019fc986-283d-74a8-a193-7ec34f92620a",
        "storage_key": "property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments Lenexa with Pool - Prairie Creek",
      "seo_description": "Explore Prairie Creek's luxury Lenexa apartments with pool access and top-tier amenities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "generator",
      "page_item_url": "in-unit-washer-dryer-apartments-johnson-county",
      "search_query": "in-unit washer dryer apartments Johnson County",
      "category": "Amenity",
      "h1_title": "In-Unit Washer Dryer Apartments Johnson County",
      "h2_subtitle": "Find apartments with in-unit washer and dryer options. Conveniently located in Johnson County, Prairie Creek offers modern amenities.",
      "page_copy": "Prairie Creek Apartments & Townhomes provides a convenient lifestyle for those seeking in-unit washer dryer apartments in Johnson County. Enjoy the ultimate convenience of doing laundry from the comfort of your own home with our modern, in-unit washer and dryer features.\n\nSituated in the peaceful Outlying Johnson County area, Prairie Creek balances luxury with practicality. With additional amenities like walking/biking trails, extra storage, and services such as a personal trainer, our community offers both comfort and style. Explore our Lenexa location today and see how easy life can be with in-unit washer dryer apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, adjacent to an outdoor kitchen and dining area.",
        "public_id": "019fc986-283d-74a8-a193-7ec34f92620a",
        "storage_key": "property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Washer Dryer Apartments in Johnson County",
      "seo_description": "Discover Prairie Creek's apartments in Johnson County with in-unit washer dryer. Enjoy convenience with modern amenities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "generator",
      "page_item_url": "apartments-with-fitness-center-lenexa-ks",
      "search_query": "apartments with fitness center Lenexa KS",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center Lenexa KS",
      "h2_subtitle": "Enjoy the convenience of our on-site fitness center. Prairie Creek in Lenexa, KS offers modern apartments with luxurious amenities.",
      "page_copy": "At Prairie Creek Apartments & Townhomes, you can stay healthy and active with our state-of-the-art fitness center. Located in Lenexa, KS, our community ensures that you have everything you need just steps from your door. Our fitness center is fully equipped and available to all residents, making it easy to maintain a healthy lifestyle.\n\nBeyond the fitness center, Prairie Creek offers a variety of stylish apartments that feature polished finishes and spacious layouts. Located in Johnson County's serene Outlying region, residents enjoy amenities like walking and biking trails, extra storage, and a renters insurance program, making it an ideal place to call home. Discover the balance of activity and relaxation at our Lenexa, KS apartments today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, adjacent to an outdoor kitchen and dining area.",
        "public_id": "019fc986-283d-74a8-a193-7ec34f92620a",
        "storage_key": "property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center in Lenexa KS",
      "seo_description": "Explore Prairie Creek's apartments with a fitness center in Lenexa, KS. Enjoy a healthy lifestyle with modern amenities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "generator",
      "page_item_url": "lenexa-ks-pet-friendly-apartments-with-park-access",
      "search_query": "Lenexa KS pet friendly apartments with park access",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments with Park Access Lenexa KS",
      "h2_subtitle": "Discover pet-friendly living in Lenexa, KS with park access. Prairie Creek offers a perfect home for you and your furry friends.",
      "page_copy": "Prairie Creek Apartments & Townhomes in Lenexa, KS, is the ideal community for pet lovers. Our pet-friendly apartments provide easy access to nearby parks, offering the perfect setting for you and your furry companions to enjoy outdoor adventures. With expansive walking and biking trails, our location ensures plenty of spaces for your pets to explore.\n\nLocated in the tranquil Outlying Johnson County area, Prairie Creek combines luxury living with pet-friendly amenities. Our spacious apartments feature polished finishes and numerous communal amenities like extra storage and personal training services. Embrace a lifestyle that caters to both you and your pets at our Lenexa, KS community; schedule a visit today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, adjacent to an outdoor kitchen and dining area.",
        "public_id": "019fc986-283d-74a8-a193-7ec34f92620a",
        "storage_key": "property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments with Park Access Lenexa KS",
      "seo_description": "Find pet-friendly apartments in Lenexa, KS with park access at Prairie Creek. Enjoy nearby trails and pet-friendly amenities. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "generator",
      "page_item_url": "attached-garage-townhomes-outlying-johnson-county",
      "search_query": "attached garage townhomes in Outlying Johnson County",
      "category": "Amenity",
      "h1_title": "Attached Garage Townhomes Outlying Johnson County",
      "h2_subtitle": "Explore townhomes with attached garages in Outlying Johnson County. Prairie Creek offers comfort and convenience in Lenexa.",
      "page_copy": "Prairie Creek Apartments & Townhomes presents a refined living experience in Outlying Johnson County with our townhomes featuring attached garages. These spacious residences offer both privacy and convenience, allowing you to enjoy direct access from your garage to your home.\n\nNestled in the serene landscape of Lenexa, our community boasts polished finishes and modern amenities, such as walking/biking trails, extra storage, and a renters insurance program. Whether you seek a peaceful retreat or a lively community atmosphere, Prairie Creek provides the perfect blend of both. Discover the effortless lifestyle available in our attached garage townhomes today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, adjacent to an outdoor kitchen and dining area.",
        "public_id": "019fc986-283d-74a8-a193-7ec34f92620a",
        "storage_key": "property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Attached Garage Townhomes in Outlying Johnson County",
      "seo_description": "Discover attached garage townhomes at Prairie Creek in Outlying Johnson County. Experience luxury living with modern amenities. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-lenexa-ks",
      "search_query": "one bedroom apartments lenexa ks",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Lenexa KS",
      "h2_subtitle": "Find stylish one-bedroom apartments in Lenexa, KS. Prairie Creek offers modern living with top amenities.",
      "page_copy": "Prairie Creek Apartments & Townhomes offer beautifully designed one-bedroom apartments located in the heart of Lenexa, KS. These residences are perfect for those seeking modern comforts blended with elegant style. Each unit features polished finishes and ample space, providing a cozy yet sophisticated home environment.\n\nBeyond the confines of your apartment, you’ll enjoy access to a variety of community amenities such as walking and biking trails, extra storage options, and a personal trainer service. Located in Outlying Johnson County, Prairie Creek ensures you can relax in comfort while having easy access to all that Lenexa has to offer. Experience unmatched convenience and charm with our one-bedroom apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, adjacent to an outdoor kitchen and dining area.",
        "public_id": "019fc986-283d-74a8-a193-7ec34f92620a",
        "storage_key": "property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Lenexa KS",
      "seo_description": "Explore one-bedroom apartments in Lenexa, KS at Prairie Creek. Enjoy modern amenities and stylish living spaces. Schedule a visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "generator",
      "page_item_url": "two-bedroom-townhomes-outlying-johnson-county",
      "search_query": "two bedroom townhomes outlying johnson county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Townhomes Outlying Johnson County",
      "h2_subtitle": "Explore spacious two-bedroom townhomes in Outlying Johnson County. Enjoy comfort and amenities at Prairie Creek.",
      "page_copy": "Discover the perfect two-bedroom townhomes at Prairie Creek, nestled in the peaceful community of Outlying Johnson County. Designed with you in mind, these townhomes offer expansive living spaces and attached garages, making them ideal for both families and individuals seeking extra room.\n\nLocated in vibrant Lenexa, KS, our community ensures convenience and comfort with amenities such as walking and biking trails, additional storage, and access to personal training sessions. Your new home awaits at Prairie Creek Apartments & Townhomes, where modern living meets tranquil surroundings. Schedule a tour today and experience the best in contemporary living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, adjacent to an outdoor kitchen and dining area.",
        "public_id": "019fc986-283d-74a8-a193-7ec34f92620a",
        "storage_key": "property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Townhomes Outlying Johnson County",
      "seo_description": "Find two-bedroom townhomes in Outlying Johnson County at Prairie Creek. Enjoy spacious living and modern amenities. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "generator",
      "page_item_url": "three-bedroom-floorplans-prairie-creek-apartments",
      "search_query": "three bedroom floorplans prairie creek apartments",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Floorplans at Prairie Creek",
      "h2_subtitle": "Discover spacious three-bedroom floorplans at Prairie Creek Apartments. Experience roominess and comfort in Lenexa.",
      "page_copy": "Prairie Creek Apartments & Townhomes in Lenexa, KS, offer expansive three-bedroom floorplans perfect for those who need more space. Each layout is thoughtfully designed with polished finishes and ample storage, ensuring a comfortable living experience for families or roommates.\n\nBeyond the thoughtfully crafted interiors, residents can enjoy a variety of shared amenities, including walking and biking trails, a renters insurance program, and access to a personal trainer. Nestled in Outlying Johnson County, Prairie Creek provides a tranquil yet convenient community environment. Explore our three-bedroom floorplans and find your new home today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, adjacent to an outdoor kitchen and dining area.",
        "public_id": "019fc986-283d-74a8-a193-7ec34f92620a",
        "storage_key": "property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Floorplans at Prairie Creek",
      "seo_description": "Explore spacious three-bedroom floorplans at Prairie Creek Apartments, Lenexa. Enjoy modern amenities and generous living spaces. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "generator",
      "page_item_url": "apartments-near-lenexa-hills-elementary",
      "search_query": "apartments near Lenexa Hills Elementary",
      "category": "School",
      "h1_title": "Apartments Near Lenexa Hills Elementary",
      "h2_subtitle": "Find ideal apartments near Lenexa Hills Elementary. Prairie Creek offers convenient and stylish living in Lenexa.",
      "page_copy": "Located just a short distance from Lenexa Hills Elementary, Prairie Creek Apartments & Townhomes provide the perfect blend of convenience and style. Families will appreciate the proximity to this esteemed school, making morning commutes a breeze.\n\nPrairie Creek offers a variety of apartment layouts with high-end finishes and practical features like extra storage and a renters insurance program. Residents also have access to community amenities such as walking and biking trails and the services of a personal trainer. Experience the advantage of living close to top schools and enjoy a vibrant community atmosphere.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, adjacent to an outdoor kitchen and dining area.",
        "public_id": "019fc986-283d-74a8-a193-7ec34f92620a",
        "storage_key": "property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Lenexa Hills Elementary",
      "seo_description": "Find convenient apartments near Lenexa Hills Elementary at Prairie Creek. Enjoy modern amenities and a community setting. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "generator",
      "page_item_url": "townhomes-close-to-sunflower-elementary-school-lenexa",
      "search_query": "townhomes close to Sunflower Elementary School Lenexa",
      "category": "School",
      "h1_title": "Townhomes Close to Sunflower Elementary",
      "h2_subtitle": "Explore townhomes conveniently located near Sunflower Elementary School in Lenexa. Enjoy space and modern amenities at Prairie Creek.",
      "page_copy": "Prairie Creek Apartments & Townhomes offer the perfect location for families, just minutes from Sunflower Elementary School in Lenexa. Our spacious townhomes are designed with family-friendly features, including attached garages and ample living spaces.\n\nLiving at Prairie Creek not only provides proximity to a reputable school but also a community rich with amenities. Residents can benefit from our walking and biking trails, extra storage options, and personal training services. These townhomes offer the ideal setting for both convenience and comfort in Outlying Johnson County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, adjacent to an outdoor kitchen and dining area.",
        "public_id": "019fc986-283d-74a8-a193-7ec34f92620a",
        "storage_key": "property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Townhomes Close to Sunflower Elementary",
      "seo_description": "Discover townhomes near Sunflower Elementary School in Lenexa at Prairie Creek. Experience convenient living with modern amenities. Schedule a visit now!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "generator",
      "page_item_url": "apartments-near-christa-mcauliffe-elementary-ks",
      "search_query": "apartments near Christa McAuliffe Elementary KS",
      "category": "School",
      "h1_title": "Apartments Near Christa McAuliffe Elementary",
      "h2_subtitle": "Discover apartments close to Christa McAuliffe Elementary in KS. Prairie Creek offers convenience and modern living.",
      "page_copy": "Situated conveniently near Christa McAuliffe Elementary in Kansas, Prairie Creek Apartments & Townhomes offer a perfect blend of accessibility and style. Families and professionals alike will appreciate the ease of living close to one of Lenexa's well-regarded schools.\n\nPrairie Creek boasts a range of apartment layouts, complemented by upscale finishes and community features like walking and biking trails. With amenities such as extra storage and a renters insurance program, residents enjoy a seamless and active lifestyle within a nurturing environment. Choose Prairie Creek for proximity and quality living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, adjacent to an outdoor kitchen and dining area.",
        "public_id": "019fc986-283d-74a8-a193-7ec34f92620a",
        "storage_key": "property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Christa McAuliffe Elementary",
      "seo_description": "Explore apartments near Christa McAuliffe Elementary in KS at Prairie Creek. Enjoy convenient access and modern amenities. Visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "generator",
      "page_item_url": "townhomes-near-rosehill-elementary-school-johnson-county",
      "search_query": "townhomes near Rosehill Elementary School Johnson County",
      "category": "School",
      "h1_title": "Townhomes Near Rosehill Elementary School",
      "h2_subtitle": "Explore townhomes conveniently located near Rosehill Elementary School in Johnson County, offering spacious living and modern amenities at Prairie Creek.",
      "page_copy": "Prairie Creek Apartments & Townhomes, located near Rosehill Elementary School in Johnson County, offer a compelling option for families seeking comfort and convenience. Our townhomes are thoughtfully designed with spacious layouts and polished finishes, perfect for those who value quality living.\n\nResiding at Prairie Creek means more than just proximity to a great school. Residents can enjoy extra storage options, access to a renters insurance program, and communal amenities like walking and biking trails. Experience the perfect combination of modern amenities and a family-friendly environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, adjacent to an outdoor kitchen and dining area.",
        "public_id": "019fc986-283d-74a8-a193-7ec34f92620a",
        "storage_key": "property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Townhomes Near Rosehill Elementary School",
      "seo_description": "Find townhomes near Rosehill Elementary School in Johnson County at Prairie Creek. Enjoy spacious layouts and top amenities. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "generator",
      "page_item_url": "apartments-close-to-westridge-middle-school-66219",
      "search_query": "apartments close to Westridge Middle School 66219",
      "category": "School",
      "h1_title": "Apartments Close to Westridge Middle School",
      "h2_subtitle": "Discover apartments near Westridge Middle School in the 66219 ZIP code. Prairie Creek offers ideal living in Lenexa.",
      "page_copy": "Located in the heart of Lenexa, Prairie Creek Apartments & Townhomes offer a prime location close to Westridge Middle School, situated in the 66219 ZIP code. Perfect for families and individuals, our apartments feature modern designs and amenities tailored for comfort and convenience.\n\nExperience community living with access to walking and biking trails, extra storage options, and the option for a personal trainer on-site. Prairie Creek ensures that residents enjoy not only proximity to a top middle school but also the benefits of a vibrant and well-equipped community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, adjacent to an outdoor kitchen and dining area.",
        "public_id": "019fc986-283d-74a8-a193-7ec34f92620a",
        "storage_key": "property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Westridge Middle School",
      "seo_description": "Explore Prairie Creek apartments near Westridge Middle School in 66219. Enjoy modern living and excellent community amenities. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "generator",
      "page_item_url": "lenexa-apartments-near-shawnee-mission-west-high-school",
      "search_query": "lenexa apartments near Shawnee Mission West High School",
      "category": "School",
      "h1_title": "Lenexa Apartments Near Shawnee Mission West",
      "h2_subtitle": "Discover the convenience of Lenexa apartments near Shawnee Mission West High School, offering modern living at Prairie Creek.",
      "page_copy": "Prairie Creek Apartments & Townhomes in Lenexa provide an exceptional living experience right near Shawnee Mission West High School. Perfectly situated for students and families, our apartments allow easy access to educational and extracurricular activities.\n\nEnjoy the comfort of spacious and stylish apartment designs alongside community amenities such as walking trails and extra storage options. With options for a den or study, and access to a renters insurance program, Prairie Creek combines practicality with upscale living, right in the proximity of renowned schools.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, adjacent to an outdoor kitchen and dining area.",
        "public_id": "019fc986-283d-74a8-a193-7ec34f92620a",
        "storage_key": "property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lenexa Apartments Near Shawnee Mission West",
      "seo_description": "Find Lenexa apartments near Shawnee Mission West High School at Prairie Creek. Enjoy modern amenities and convenience. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "generator",
      "page_item_url": "apartments-close-to-johnson-county-community-college",
      "search_query": "apartments close to Johnson County Community College",
      "category": "School",
      "h1_title": "Apartments Near Johnson County Community College",
      "h2_subtitle": "Explore the benefits of living near Johnson County Community College with apartments offering modern amenities at Prairie Creek in Lenexa.",
      "page_copy": "Prairie Creek Apartments & Townhomes are ideally located for students and staff seeking proximity to Johnson County Community College. Our Lenexa apartments combine convenience with contemporary living, providing a perfect fit for academic pursuits.\n\nExperience exceptional lifestyle options, including walking and biking trails, ample storage, and the possibility of having a personal trainer. Whether you're studying or working at the college, Prairie Creek offers a balanced lifestyle with stylish, spacious homes and valuable community features.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, adjacent to an outdoor kitchen and dining area.",
        "public_id": "019fc986-283d-74a8-a193-7ec34f92620a",
        "storage_key": "property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Johnson County Community College",
      "seo_description": "Discover apartments near Johnson County Community College at Prairie Creek in Lenexa. Enjoy modern living and amenities. Schedule a visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "generator",
      "page_item_url": "townhomes-near-holy-trinity-school-johnson-county",
      "search_query": "townhomes near Holy Trinity School Outlying Johnson County",
      "category": "School",
      "h1_title": "Townhomes Near Holy Trinity School",
      "h2_subtitle": "Find ideal townhome living near Holy Trinity School in Outlying Johnson County at Prairie Creek. Enjoy community and convenience.",
      "page_copy": "Situated in the serene Outlying Johnson County, Prairie Creek Apartments & Townhomes offer a perfect living solution near Holy Trinity School. Our townhomes provide spacious, stylish layouts, ideal for families seeking both comfort and proximity to quality education.\n\nResidents benefit from a range of amenities, such as extra storage options and inviting walking and biking trails. Located in a welcoming community, Prairie Creek ensures that families are not only close to Holy Trinity School but also have access to a peaceful, enriching living environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, adjacent to an outdoor kitchen and dining area.",
        "public_id": "019fc986-283d-74a8-a193-7ec34f92620a",
        "storage_key": "property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Townhomes Near Holy Trinity School",
      "seo_description": "Discover townhomes near Holy Trinity School in Outlying Johnson County at Prairie Creek. Enjoy spacious living and modern amenities. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "generator",
      "page_item_url": "apartments-near-adventhealth-lenexa-city-center",
      "search_query": "apartments near AdventHealth Lenexa City Center",
      "category": "Hospital",
      "h1_title": "Apartments Near AdventHealth Lenexa City Center",
      "h2_subtitle": "Experience convenient living with apartments near AdventHealth Lenexa City Center. Enjoy proximity and modern comforts at Prairie Creek.",
      "page_copy": "Prairie Creek Apartments & Townhomes are situated just minutes from AdventHealth Lenexa City Center, offering an ideal residential option for healthcare professionals and visitors seeking nearby accommodations. Our community combines convenience with high-quality living.\n\nFeaturing resort-style amenities such as walking and biking trails, as well as extra storage options, Prairie Creek ensures a comfortable lifestyle. Whether you're looking to relax after a busy day or need easy access to the healthcare center and surrounding areas, our Lenexa apartments are perfectly positioned.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, adjacent to an outdoor kitchen and dining area.",
        "public_id": "019fc986-283d-74a8-a193-7ec34f92620a",
        "storage_key": "property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near AdventHealth Lenexa City Center",
      "seo_description": "Find apartments near AdventHealth Lenexa City Center at Prairie Creek. Enjoy modern living and easy access. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "generator",
      "page_item_url": "prairie-creek-apartments-close-to-overland-park-regional",
      "search_query": "Prairie Creek apartments close to Overland Park Regional Medical Center",
      "category": "Hospital",
      "h1_title": "Prairie Creek: Close to Overland Park Regional",
      "h2_subtitle": "Explore Prairie Creek Apartments, located conveniently close to Overland Park Regional Medical Center. Perfect blend of comfort and location.",
      "page_copy": "For those seeking easy access to Overland Park Regional Medical Center, Prairie Creek Apartments & Townhomes offer an exceptional living choice. Situated in the vibrant Lenexa area, our apartments provide a stylish and convenient home base.\n\nResidents enjoy polished finishes and resort-style amenities, including the option for personal training sessions and inviting walking and biking trails. Prairie Creek ensures that both healthcare professionals and visitors can enjoy a peaceful, accommodating environment close to essential services.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, adjacent to an outdoor kitchen and dining area.",
        "public_id": "019fc986-283d-74a8-a193-7ec34f92620a",
        "storage_key": "property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Prairie Creek: Close to Overland Park Regional",
      "seo_description": "Discover Prairie Creek Apartments, close to Overland Park Regional Medical Center. Enjoy style, comfort, and convenience. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "generator",
      "page_item_url": "apartments-near-electric-park-lenexa",
      "search_query": "apartments near Electric Park Lenexa",
      "category": "Park",
      "h1_title": "Apartments Near Electric Park Lenexa",
      "h2_subtitle": "Live close to Electric Park with our Lenexa apartments. Prairie Creek offers community, convenience, and comfort.",
      "page_copy": "Nestled in the heart of Lenexa, Prairie Creek Apartments & Townhomes provide an exciting living experience near Electric Park. Perfect for those who love vibrant community activities, our apartments offer easy access to the park and its lively events.\n\nResidents enjoy a harmonious blend of style and convenience, with amenities like extra storage and walking/biking trails right at their doorstep. Praire Creek is the ideal choice for anyone looking to enjoy the recreational offerings of Electric Park while relishing a tranquil home environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, adjacent to an outdoor kitchen and dining area.",
        "public_id": "019fc986-283d-74a8-a193-7ec34f92620a",
        "storage_key": "property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Electric Park Lenexa",
      "seo_description": "Find your new home near Electric Park in Lenexa at Prairie Creek. Enjoy stylish living and easy access to community activities. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "generator",
      "page_item_url": "apartments-close-to-scouting-park-66219",
      "search_query": "apartments close to Scouting Park 66219",
      "category": "Park",
      "h1_title": "Apartments Close to Scouting Park 66219",
      "h2_subtitle": "Discover our Lenexa apartments close to Scouting Park, offering a blend of convenience and serenity. Prairie Creek is a community you’ll love.",
      "page_copy": "Located close to Scouting Park in the 66219 area, Prairie Creek Apartments & Townhomes offer a perfect haven for outdoor enthusiasts and families alike. Enjoy easy access to local greenery and recreational opportunities while living in a spacious, modern community.\n\nAt Prairie Creek, you’ll find a range of exceptional amenities, including a renters insurance program and personal trainers to enhance your lifestyle. Whether you’re out for a stroll in the nearby park or relaxing in the comfort of our community spaces, Prairie Creek is designed for both convenience and comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, adjacent to an outdoor kitchen and dining area.",
        "public_id": "019fc986-283d-74a8-a193-7ec34f92620a",
        "storage_key": "property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Scouting Park 66219",
      "seo_description": "Live near Scouting Park in 66219 at Prairie Creek. Enjoy convenience and modern amenities in a welcoming community. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "generator",
      "page_item_url": "prairie-creek-apartments-by-tamarisk-park",
      "search_query": "Prairie Creek Apartments by Tamarisk Park",
      "category": "Park",
      "h1_title": "Prairie Creek Apartments by Tamarisk Park",
      "h2_subtitle": "Experience the ideal blend of nature and modern living at Prairie Creek Apartments, situated near the serene Tamarisk Park.",
      "page_copy": "Prairie Creek Apartments & Townhomes offer an idyllic living experience just moments away from Tamarisk Park in Lenexa. With beautifully designed spaces and the park’s green expanses nearby, it's a fantastic location for those who appreciate both urban and natural settings.\n\nOur community boasts upscale amenities, including spacious floor plans and inviting walking/biking trails, ensuring an active and relaxed lifestyle. Residents can enjoy peaceful strolls in Tamarisk Park or relax in their elegantly finished homes, making Prairie Creek an exceptional choice for all lifestyles.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, adjacent to an outdoor kitchen and dining area.",
        "public_id": "019fc986-283d-74a8-a193-7ec34f92620a",
        "storage_key": "property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Prairie Creek Apartments by Tamarisk Park",
      "seo_description": "Discover Prairie Creek Apartments, conveniently located by Tamarisk Park. Enjoy a blend of nature and modern living. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "generator",
      "page_item_url": "townhomes-near-mill-creek-streamway-park-ks",
      "search_query": "townhomes near Mill Creek Streamway Park KS",
      "category": "Park",
      "h1_title": "Townhomes Near Mill Creek Streamway Park KS",
      "h2_subtitle": "Explore townhome living near Mill Creek Streamway Park, KS. Prairie Creek offers spacious designs and proximity to nature trails.",
      "page_copy": "Prairie Creek Apartments & Townhomes provide an enhanced lifestyle experience near Mill Creek Streamway Park in Kansas. Perfect for those who love outdoor adventures, our townhomes offer easy access to the park’s extensive trail system, ideal for biking and hiking enthusiasts.\n\nWith polished finishes and optional attached garages, our townhomes cater to modern living needs while ensuring proximity to scenic nature. Whether you're enjoying the calming Creek trails or the extensive community amenities like personal trainers and extra storage, Prairie Creek offers an unbeatable blend of comfort and adventure.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, adjacent to an outdoor kitchen and dining area.",
        "public_id": "019fc986-283d-74a8-a193-7ec34f92620a",
        "storage_key": "property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Townhomes Near Mill Creek Streamway Park KS",
      "seo_description": "Find townhomes near Mill Creek Streamway Park, KS at Prairie Creek. Enjoy proximity to trails and modern amenities. Contact us for a visit!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "generator",
      "page_item_url": "apartments-in-johnson-county-near-central-green-park",
      "search_query": "apartments in Johnson County near Central Green Park",
      "category": "Park",
      "h1_title": "Apartments in Johnson County Near Central Green Park",
      "h2_subtitle": "Live in the heart of Johnson County, close to Central Green Park. Discover Prairie Creek Apartments' perfect blend of community and comfort.",
      "page_copy": "Nestled in Johnson County, Prairie Creek Apartments & Townhomes offer a vibrant living experience near the charming Central Green Park. Our beautifully designed spaces provide a serene retreat while keeping you connected to the community’s heart.\n\nResidents enjoy a plethora of modern amenities, including walking/biking trails that promote an active lifestyle. With elegant finishes and spacious layouts, Prairie Creek ensures comfort and convenience just steps away from Central Green Park's lush greenery. Experience the ideal blend of leisure and luxury right here.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, adjacent to an outdoor kitchen and dining area.",
        "public_id": "019fc986-283d-74a8-a193-7ec34f92620a",
        "storage_key": "property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments in Johnson County Near Central Green Park",
      "seo_description": "Discover Prairie Creek Apartments in Johnson County, close to Central Green Park. Enjoy comfort and community amenities in a prime location. Visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "generator",
      "page_item_url": "buffalo-meadows-park-adjacent-apartment-rentals",
      "search_query": "Buffalo Meadows Park adjacent apartment rentals",
      "category": "Park",
      "h1_title": "Apartment Rentals by Buffalo Meadows Park",
      "h2_subtitle": "Find your next home near Buffalo Meadows Park. Prairie Creek offers apartment rentals with abundant amenities and nature access.",
      "page_copy": "Located next to the serene Buffalo Meadows Park, Prairie Creek Apartments & Townhomes offer a dynamic living environment in Lenexa. Enjoy easy park access while living in a community that prioritizes modern convenience and outdoor adventures.\n\nOur residences feature luxurious amenities, from polished interiors and extra storage to walking and biking trails, encouraging a healthy lifestyle. Whether you're enjoying a leisurely park day or benefitting from on-site personal trainers, Prairie Creek merges comfortable living with the appeal of nearby Buffalo Meadows.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, adjacent to an outdoor kitchen and dining area.",
        "public_id": "019fc986-283d-74a8-a193-7ec34f92620a",
        "storage_key": "property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Rentals by Buffalo Meadows Park",
      "seo_description": "Explore Prairie Creek's apartment rentals next to Buffalo Meadows Park. Enjoy modern amenities and parkside living. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "generator",
      "page_item_url": "prairie-creek-apartments-near-sar-ko-par-trails-park",
      "search_query": "Prairie Creek Apartments near Sar-Ko-Par Trails Park",
      "category": "Park",
      "h1_title": "Prairie Creek Near Sar-Ko-Par Trails Park",
      "h2_subtitle": "Experience the charm of living near Sar-Ko-Par Trails Park. Prairie Creek Apartments offers modern amenities and scenic views.",
      "page_copy": "Located in Lenexa, Prairie Creek Apartments & Townhomes boast an ideal spot near Sar-Ko-Par Trails Park, perfect for nature lovers looking to enjoy nearby outdoor spaces. Whether you're taking a morning jog or an evening stroll, the proximity to the park offers residents easy access to breathtaking trails and relaxing greenery.\n\nPrairie Creek combines this natural connection with upscale living. With chic apartment designs, optional attached garages, and community features like walking and biking trails, you’ll find both adventure and tranquility at your doorstep. Make Prairie Creek your new home and embrace park-side living with all the comforts you desire.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, adjacent to an outdoor kitchen and dining area.",
        "public_id": "019fc986-283d-74a8-a193-7ec34f92620a",
        "storage_key": "property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Prairie Creek Near Sar-Ko-Par Trails Park",
      "seo_description": "Live near Sar-Ko-Par Trails Park at Prairie Creek Apartments. Enjoy modern living with park access and superb amenities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "generator",
      "page_item_url": "flat-rock-creek-park-nearby-townhomes",
      "search_query": "Flat Rock Creek Park nearby townhomes",
      "category": "Park",
      "h1_title": "Townhomes by Flat Rock Creek Park",
      "h2_subtitle": "Discover townhome living near Flat Rock Creek Park. Prairie Creek offers spacious layouts and premium community amenities.",
      "page_copy": "Prairie Creek Apartments & Townhomes are ideally situated by the tranquil Flat Rock Creek Park, offering a unique living experience in Lenexa. Embrace the blend of suburban comfort and natural beauty, just a short walk from picturesque park paths.\n\nOur townhomes provide spacious layouts with stylish finishes and optional attached garages. As a resident, you'll relish in amenities such as walking/biking trails and extra storage, ensuring both convenience and recreation. With Flat Rock Creek Park nearby, Prairie Creek is the perfect setting for those seeking a harmonious lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, adjacent to an outdoor kitchen and dining area.",
        "public_id": "019fc986-283d-74a8-a193-7ec34f92620a",
        "storage_key": "property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Townhomes by Flat Rock Creek Park",
      "seo_description": "Explore Prairie Creek's townhomes near Flat Rock Creek Park. Enjoy beautiful surroundings and modern amenities. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "generator",
      "page_item_url": "prairie-creek-apartments-close-to-black-hoof-park",
      "search_query": "Prairie Creek Apartments close to Black Hoof Park",
      "category": "Park",
      "h1_title": "Prairie Creek Apartments Near Black Hoof Park",
      "h2_subtitle": "Live close to Black Hoof Park at Prairie Creek. Discover spacious living and modern amenities just steps from natural beauty.",
      "page_copy": "Experience the perfect blend of nature and modern living at Prairie Creek Apartments & Townhomes, located just minutes from Black Hoof Park in Lenexa. This prime location ensures residents can easily enjoy the park's scenic trails, serene lake, and lush green spaces.\n\nPrairie Creek offers residents upscale amenities such as chic interiors, optional attached garages, and access to walking and biking trails. Our community fosters an active lifestyle while providing comfortable retreats. Discover the joys of living near Black Hoof Park with all the conveniences Prairie Creek has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, adjacent to an outdoor kitchen and dining area.",
        "public_id": "019fc986-283d-74a8-a193-7ec34f92620a",
        "storage_key": "property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Prairie Creek Near Black Hoof Park",
      "seo_description": "Prairie Creek Apartments are close to Black Hoof Park. Experience park-side living with modern amenities. Schedule a visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167608",
      "source": "generator",
      "page_item_url": "apartments-near-kansas-city-international-airport",
      "search_query": "apartments near kansas city international airport",
      "category": "Transit",
      "h1_title": "Apartments Near Kansas City International Airport",
      "h2_subtitle": "Enjoy convenient living at Prairie Creek, minutes from Kansas City International Airport. Discover modern amenities in a serene setting.",
      "page_copy": "Prairie Creek Apartments & Townhomes are conveniently located within easy reach of Kansas City International Airport, making travel seamless for frequent flyers. This strategic location in Lenexa not only provides easy airport access but also keeps all of Kansas City's opportunities and amenities within reach.\n\nOur community features a blend of modern living with resort-style amenities, including stylish apartment finishes, attached garage options, and extensive walking/biking trails. Prairie Creek offers a peaceful residential setting while keeping you close to major travel hubs, perfectly balancing convenience and comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, adjacent to an outdoor kitchen and dining area.",
        "public_id": "019fc986-283d-74a8-a193-7ec34f92620a",
        "storage_key": "property/6767906449167608/019fc986-283d-74a8-a193-7ec34f92620a.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kansas City Intl Airport",
      "seo_description": "Find convenience at Prairie Creek, near Kansas City International Airport. Enjoy modern living and easy access to travel. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12701899434"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-5QZC33CD"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Batch 4"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Rise"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/c5bf351c-782d-4d47-9c7f-24372e0262d8/app.js?nocache=1&gaTracking=G-STGWMPXRVE&buttonbgcolor=512a44&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "913-430-1306"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InBkSXU5QTJSNGoySmlsc0JNOVpEa3c9PSIsInZhbHVlIjoieDhBL0FHSkxpN0dIa3U0N3F6d1RaZz09IiwibWFjIjoiZjMwNmEyYmRhZDg0MDkwZTdmOWVhZGViODQ3YTgxNTI0YjkyOTUzYzk3OWU1MTk5OWZiMmFjNGFjODA4MDgxZSJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_repli_id": "12701899434",
  "custom_google_gtm_id": "GTM-5QZC33CD",
  "custom_rollout_phase": "Batch 4",
  "custom_vibesites_theme": "Rise",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/c5bf351c-782d-4d47-9c7f-24372e0262d8/app.js?nocache=1&gaTracking=G-STGWMPXRVE&buttonbgcolor=512a44&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>",
  "custom_seo_subscription": "essential",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "913-430-1306",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InBkSXU5QTJSNGoySmlsc0JNOVpEa3c9PSIsInZhbHVlIjoieDhBL0FHSkxpN0dIa3U0N3F6d1RaZz09IiwibWFjIjoiZjMwNmEyYmRhZDg0MDkwZTdmOWVhZGViODQ3YTgxNTI0YjkyOTUzYzk3OWU1MTk5OWZiMmFjNGFjODA4MDgxZSJ9",
  "custom_audioeye_site_id": "42f01a2e-19a2-409d-84c5-64cdf7b3e0ac",
  "custom_audioeye_site_hash": "30a7b56a019dfd320aba581d61c8aec4"
};

export const generatedAt = '2026-11-03T23:01:12.158Z';
